<template>
  <div>
    
    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input :key="'searchtxt'" 
            icon-pack="feather"
            icon="icon-search"
            :placeholder="beneficiaryId ==null?'Search by Case No':'Search by Case No'"
            class="is-label-placeholder"
            v-model.lazy="searchtxt"
          />
         
        </div>
         <div class=" con-select  selection_search" v-if="false" >
                    
                     <multiselect
                      @input="getpetitions(true);"
                      v-model="selectedDeletedCase"
                      :options="caselist"
                      :multiple="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                      :allow-empty="true"
                    >
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Case Type(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
       </div>
      </div>
      <div class="con-select selection_search casetype" v-if="[51].indexOf(getUserRoleId) < 0  && false">
        <multiselect @input="changedVisaTypeClear" v-model="selectedVisaType" :options="visaTypes" :multiple="false"
          :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Case Type"
          label="name" track-by="name" :preselect-first="false">

          <template slot="selection" slot-scope="{ values, isOpen }">
            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }} Case Type(s)
              Selected</span>
            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
          </template>
        </multiselect>
      </div>
       
      <div class="content-header-right">
        <!--filter dropdown-->
        
        <vs-dropdown vs-custom-content vs-trigger-click v-if="false">
          <vs-button
            color="primary"
            class="filter-btn"
            type="border"
            icon-pack="feather"
            icon="icon-chevron-down"
            icon-after
          >
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button>
          <vs-dropdown-menu ref="filter_menu" class="filters-content">
            <div class="filters-form-fileds">
              <div class="form-container">
                <div class="vx-row">
                  <div class="vx-col md:w-1/3 w-full con-select filters-search">
                    <label class="typo__label">Search</label>
                    <vs-input :key="'filter_searchtxt'"
                      icon-pack="feather"
                      icon
                      class="is-label-placeholder"
                      v-model="filter_searchtxt"
                    />
                  </div>
                  
                  <div class="vx-col md:w-1/3 w-full con-select" v-if="false && [3].indexOf(getUserRoleId)>-1 && this.beneficiaryId==null" >
                    <label class="typo__label">Select Branch</label>
                    <multiselect
                      v-model="selectedBranches"
                      :options="branchList"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Branch"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Branches Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Status</label>
                    <multiselect
                      v-model="selected_statusids"
                      :options="all_statusids"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span>
                      </template> -->
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Status Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                 
                  
                   <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Case Type</label>
                    <multiselect
                      @input="changedVisaType"
                      v-model="selectedVisaType"
                      :options="visaTypes"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Case Type"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Case Type(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                  <!---all_subtypes---->
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Case Subtype</label>
                    <multiselect
                      @input="changedsubtypes()"
                      v-model="selected_subtypes"
                      :options="all_subtypes"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Case Subtype"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Case Subtype(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  
                 <!--
                  <div v-if="roleId != 6 && roleId != 7" class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Users</label>
                    <multiselect
                      @input="changedusers()"
                      v-model="selected_users"
                      :options="users"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Users"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                      @search-change="user_search"
                    >
                      
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} User(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>
                  -->

                  <!-------------Select Petitioners this.all_peritioners ----------->
                   <div class="vx-col md:w-1/3 w-full con-select" v-if="[3,4,5,6,7,8,9,10,11,12,13,14].indexOf(getUserRoleId)>-1 && beneficiaryId ==null && getTenantTypeId !=2"  >
                    <label class="typo__label">Petitioners</label>
                    <multiselect @input="changedperitioners()"  v-model="selected_peritioners" :options="all_peritioners"   :multiple="true" :hideSelected="true"
                                 :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                                 placeholder="Select Petitioners" label="name" track-by="name" :preselect-first="false"
                                 @search-change="peritioners_search_fun"
                    >
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Peritioner(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>

                    </multiselect>

                  </div>
                  <!-------Select Beneficiars-------->
                  <!-- <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Beneficiars</label>
                    <multiselect ref="country_selectbox" @input="changedCountry()"  v-model="selected_country_obj" :options="countries"  :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Country" label="name" track-by="name" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                    </multiselect>

                  </div>-->
                  <!-------genders--------->
                  <!--<div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select Gender</label>
                    <multiselect ref="country_selectbox" @input="changedCountry()"  v-model="selected_country_obj" :options="countries"  :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Country" label="name" track-by="name" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                    </multiselect>

                  </div>-->
                  <!------------maritalStatusIds---------->
                  <!-- <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Select MaritalStatus</label>
                    <multiselect ref="country_selectbox" @input="changedCountry()"  v-model="selected_country_obj" :options="countries"  :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Country" label="name" track-by="name" :preselect-first="false">
                      <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                    </multiselect>

                  </div>-->

                  <!----------Select Country------->
                  <!-- <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Country</label>
                    <multiselect
                      ref="country_selectbox"
                      @input="changedCountry()"
                      v-model="selected_country_obj"
                      :options="countries"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Country"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} options selected</span>
                      </template>
                    </multiselect>
                  </div> -->

                  <!--------Select States----->
                  <!-- <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">States</label>
                    <multiselect
                      v-bind:disabled="country_code <= 0"
                      @input="changedState()"
                      v-model="seleted_states"
                      :options="all_states"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select States"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                    
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Status Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div> -->
                  <!---- seleted_locations --->
                  <!-- <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Locations</label>
                    <multiselect
                      v-bind:disabled="final_selected_states.length <= 0"
                      v-model="seleted_locations"
                      :options="all_locations"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Locations"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Location(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div> -->

                  <!------- premiumProcessingList:[true ,false],
    selectedpremiumProcessing:[{name:'Enabled' ,_id:true },{name:'Disabled' ,_id:false }],-->


                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Premium Processing</label>
                    <multiselect
                     
                      v-model="selectedpremiumProcessing"
                      :options="premiumProcessingList"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Premium Processing"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }} Premium Processing(s) Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/3 w-full con-select" v-if="[3,4].indexOf(getUserRoleId)>-1">
                    <label class="typo__label">Deleted</label>
                    <multiselect
                     
                      v-model="selectedarchive"
                      :options="[{'name':'Deleted' ,'_id':false} ,{'name':'Active' ,'_id':true}]"
                      :multiple="true" :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                     
                      <template slot="selection" slot-scope="{ values, isOpen }">
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && !isOpen"
                        >{{ values.length }}  Selected</span
                        >
                        <span
                        class="multiselect__selectcustom"
                        v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                  <!--Created Date--->
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker
                      :maxDate="new Date()"
                      :autoApply="autoApply"
                      :ranges="false" 
                      :opens="'left'"
                      v-model="selected_createdDateRange"
                    ></date-range-picker>
                  </div>
                  <div class="vx-col md:w-1/3 w-full con-select">
                    <label class="typo__label">Deadline Date</label>
                   
                    <date-range-picker
                     
                      :autoApply="autoApply"
                      :ranges="false" 
                      :opens="'left'"
                      v-model="selected_deadLineDateRange"
                    ></date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons"></div>
              <div class="right-buttons">
                <vs-button
                  color="success"
                  class="save"
                  type="filled"
                  v-on:click="set_filter()"
                >Apply</vs-button>
                <vs-button
                  color="dark"
                  class="cancel"
                  type="filled"
                  v-on:click="clear_filter($event)"
                >Clear</vs-button>
              </div>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>

  
  
        <vs-button
          color="primary"
          type="border"
          class="light-blue-btn"
          @click="selectedBeneficiary =null ; selectedPetitioner=null;addNewCase(true)"
          v-if="(!isRfe&& checkCaseCreatePermisions) || (IsSponsorLogin)|| (IsIndBeneficairyLogin)"
        >
        
        New Case <span>
          <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
        </span></vs-button>


        <!-- <vs-button
        :disabled="archiving"
          color="primary"
          type="border"
          class="light-blue-btn"
          @click="$modal.show('conformArchivemodal');"
          v-if="checkProperty(selectedForArchiveList ,'length')>0 &&[3,4].indexOf(getUserRoleId) > -1"
        >
        
        Delete <span>
          <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
        </span></vs-button> -->
        <!-- end -->
      </div>
    </div>

    <div class="accordian-table custom-table no-wrap relative">

            <NoDataFound ref="NoDataFoundRef"  :loading="isListLoading" v-if="petitioners.length == 0" content="" :heading="callFromSerch?'No Results Found':'No Cases Found'" type='petitions' />

    


      <div v-if="petitioners.length >  0">
       <div class="notes_section pl-0 pr-0" v-if="petitioners.length > 0">
       <div>
         <div class="notes_list_wrap">
          <template >
            <div class="notes_list"  v-for="(ticket, tindex) in petitioners" :key="tindex">
              <div class="notes_info" @click="petitionlink(ticket)">
                <h4  >{{ ticket.caseNo }}</h4>
                <p  >{{ checkProperty(ticket ,'typeDetails','name') }}
               <small v-if="checkProperty(ticket ,'subTypeDetails','name')" > ({{ checkProperty(ticket ,'subTypeDetails','name') }}) </small></p>
                <ul>
                  <li  v-if="checkProperty(ticket, 'petitionerDetails')">
                    <label v-if="checkProperty(ticket, 'petitionerDetails')"  >Petitioner: </label>
                    <p>
                      {{ checkProperty(ticket, "petitionerDetails", 'name') }}
                      
                    </p>
                  </li>
                  <li v-if="checkProperty(ticket,'clientInfo','name')" >
                     <label >Client: </label>
                     <p>
                        {{checkProperty(ticket,'clientInfo','name')}}
                     </p>
                  </li>
                </ul>
              </div>
              <div class="notes_status_sec">
                <template>
                <span class="statusspan "
                v-bind:class="{[getCaseColors(checkProperty(ticket ,'statusDetails','id'))]:true }"
                >{{checkProperty(ticket,'statusDetails','name') }}</span>
                </template>
              
                  <label v-if=" checkProperty(ticket, 'updatedOn')"
                  >Last Updated: 
                  <strong v-if="checkProperty(ticket, 'updatedOn')"  >
                    {{ ticket.updatedOn | formatDate }}</strong
                  >
                  </label>
                  <label v-else>
                    Created On:
                  <strong v-if="checkProperty(ticket, 'createdOn')">
                    {{ ticket.createdOn | formatDate }}</strong
                  >
                  </label>
                  <!-- v-if="(! checkProperty(ticket, 'questionnaireFilled') && checkProperty(ticket ,'intStatusDetails','id') == 1 && checkProperty(ticket, 'typeDetails', 'id') !=9)" -->
                 <div  class="right-buttons">
                    <button
                      color="primary"
                      type="border"
                      class="IB_primary-btn mt-2"
                     @click="petitionlink(ticket)" 
                      v-if="checkFillQuestionnaire(ticket)"
                     
                    ><span>Fill Questionnaire</span> 
                   </button> 
                </div>
              </div>
            </div>
          </template>
        </div>
        </div>
        </div>
        
        <vs-table :data="petitioners" v-if="false">
        <!--
          //"path": clientName "createdOn", updatedOn, createdByName, typeName, subTypeName, caseNo, statusName
          --->
          <template  v-if="petitioners.length > 0" slot="thead">
           <vs-th >
           <vs-checkbox :disabled="archiving" v-if="[3,4].indexOf(getUserRoleId) > -1 && checkEnableSelectAll" @change="selectAllforArchive()"  :name="'selecteAll'"  v-model="selectedAllForArchive" class=""></vs-checkbox>
           
           <a @click="sortMe('caseNo')" v-bind:class="{'sort_ascending':sortKeys['caseNo']==1, 'sort_descending':sortKeys['caseNo']!=1}">Case No</a>
           </vs-th>
            <vs-th v-if="[51].indexOf(getUserRoleId)<=-1" >
            
            
            <a @click="sortMe('beneficiaryName')" v-bind:class="{'sort_ascending':sortKeys['beneficiaryName']==1, 'sort_descending':sortKeys['beneficiaryName']!=1}"  >Beneficiary</a>
            
             </vs-th>
            <vs-th> <a @click="sortMe('typeName')" v-bind:class="{'sort_ascending':sortKeys['typeName']==1, 'sort_descending':sortKeys['typeName']!=1}"  >Case Type</a></vs-th>
            <vs-th v-if="[50].indexOf(getUserRoleId) <= -1 && beneficiaryId ==null && getTenantTypeId !=2" ><a @click="sortMe('createdByName')"  v-bind:class="{'sort_ascending':sortKeys['createdByName']==1, 'sort_descending':sortKeys['createdByName']!=1}"  >Petitioner</a></vs-th>
            <vs-th  >
            
            
            <a @click="sortMe('clientName')" v-bind:class="{'sort_ascending':sortKeys['clientName']==1, 'sort_descending':sortKeys['clientName']!=1}"  >Client</a>
            </vs-th>
           
            <vs-th> <a @click="sortMe('updatedOn')"  v-bind:class="{'sort_ascending':sortKeys['updatedOn']==1, 'sort_descending':sortKeys['updatedOn']!=1}" > Last Updated</a></vs-th>
         
            <vs-th > 
              <a @click="sortMe('statusName')"  v-bind:class="{'sort_ascending':sortKeys['statusName']==1, 'sort_descending':sortKeys['statusName']!=1}" >
              Status
              </a>
              </vs-th> 
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :data="petition"
              :key="petition.index"
              v-for="petition in data"
              class="vs-table--tr"
              style="cursor:pointer"
            >
              <vs-td >
              <vs-checkbox v-if="[3,4].indexOf(getUserRoleId) > - 1 && checkProperty(petition ,'status')!=false" @change="selectForArchive(petition)"  :name="'selected_'+petition.index"  v-model="petition.selectedForArchive" class=""></vs-checkbox>
              
               <!-- <img class="user-image" src="@/assets/images/main/avatar2.svg" />-->
                <template v-if=" [51].indexOf(getUserRoleId)>-1 && !checkProperty(petition ,'questionnaireFilled')" >
                <router-link
                  :to="{
                    name: 'questionnaire',
                    params: { itemId: petition._id },
                    query: {'filter':encodedString}
                  }"
                >{{ petition.caseNo }}</router-link>
                
                </template>
                 <template v-else >
                 <template v-if="isRfe">

                 <router-link
                  :to="{
                    name: 'rfe-petition-details',
                    params: { itemId: petition._id },
                     query: {'filter':encodedString}
                  }"
                >{{ petition.caseNo }}</router-link>
                 </template>
                 <template v-else>

                 <router-link
                  :to="{
                    name: 'petition-details',
                    params: { itemId: petition._id },
                    query: {'filter':encodedString}
                  }"
                >{{ petition.caseNo }}</router-link>
                 </template>
                 
                 
                </template>
                  <div class="IB_tooltip premium_tooltip"  v-if="checkProperty( petition, 'premiumProcessing')" >
                    <span>P</span>
                    <div class="tooltip_cnt">
                      <p>Premium Processing</p>
                    </div>
                  </div>
              

              </vs-td>

              <vs-td v-if="[51].indexOf(getUserRoleId)<=-1">
                <span v-if="[51].indexOf(getUserRoleId)<=-1"  @click="petitionlink(petition)" >{{ checkProperty(petition ,'beneficiaryDetails' ,'name' )  }} </span>  
                 </vs-td>

              <vs-td class="td_label">
               <div  @click="petitionlink(petition)">
                {{ checkProperty(petition ,'typeDetails','name') }} <br/>
               <small> {{ checkProperty(petition ,'subTypeDetails','name') }} </small>
               </div>
              </vs-td>
              <vs-td v-if="[50].indexOf(getUserRoleId) <= -1 && beneficiaryId ==null &&  getTenantTypeId !=2" class="content_ellipsis"><span @click="petitionlink(petition)">{{ checkProperty(petition ,'petitionerDetails','name') }}</span></vs-td>
               <vs-td  class="content_ellipsis"><span @click="petitionlink(petition)" v-if="checkProperty(petition ,'clientInfo' ,'name')" > {{petition.clientInfo.name}} </span></vs-td>
              <vs-td>
              <span @click="petitionlink(petition)">
                {{ petition.updatedOn | formatDate }}
                 <!--<a  v-if="petition.lcaId==null && currentuserRole ==6"  @click="goto(petition._id )"  class="btn btn-brown" > 
                             Request LCA </a>
                             --> 
              </span>
              </vs-td>
    
              <vs-td v-if="
                    currentuserRole == 7 &&
                     petition.questionnaireFilled &&
                      petition.questionnaireSent && petition.statusId == 1
                  " >
               <router-link  
                  
                  :to="{
                    name:'questionnaire',
                    params: { itemId: petition._id }
                  }"
                >
                  <button  class="btn btn-brown">
                    <span  >Update Questionnaire</span>
                  </button>
                </router-link>
              </vs-td>
             <vs-td v-else>

                

                <span class="statusspan" 
                @click="petitionlink(petition)"
                v-bind:class="{[getCaseColors(checkProperty(petition ,'statusDetails','id'))]:true }"
                  
                >{{ petition.statusDetails.name }}</span>
              </vs-td>

              

            </vs-tr>
          </template>
        </vs-table>

         <div class="table_footer" v-if="false">
                    

<div class="vx-col  con-select pages_select" v-if="petitioners.length > 0">
                    <label class="typo__label">Per Page</label>
                    <multiselect
                      @input="changeperPage()"
                      v-model="perpage"
                      :options="perPeges"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Per Page"
                      :allow-empty="false"
                      :preselect-first="true"
                    >
                      
                    </multiselect>
                  </div>

        <paginate
          v-if="petitioners.length > 0 "
          v-model="page"
          :page-count="totalpages"
          :page-range="3"
          :margin-pages="2"
          :click-handler="pageNate"
          prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
          next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
          :prev-text="'<i></i>'"
          :next-text="'<i></i>'"
          :container-class="'pagination vs-pagination--nav'"
          :page-class="'page-item'"
        ></paginate>
         </div>
        <vs-popup
          class="holamundo main-popup"
          title="Questionnaire"
          :active.sync="SendQuestionnaire"
        >
          <div class="media-header">
            <img src="@/assets/images/main/avatar2.svg" />
            <div class="media-content">
              <h3>{{ selecteduser.userName }}</h3>
              <p>{{ selecteduser.email }}</p>
            </div>
          </div>
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input :key="'selecteduser.typeName'"
                  class="w-full"
                  v-model="selecteduser.typeName"
                  disabled="true"
                  icon-pack="IntakePortal"
                  icon-after
                  icon="IP-disabled"
                  label="Case Type"
                />
              </div>
              <div class="vx-col w-full">
                <ckeditor  class="w-full"
                  v-model="selecteduser.instructions"
                  label="Instructions" :editor="editor" :config="editorConfig"></ckeditor>
              </div>
            </div>
          </div>
          <div class="popup-footer">
            <vs-button
              color="dark"
              @click="SendQuestionnaire = false"
              class="cancel"
              type="filled"
            >Cancel</vs-button>
            <vs-button
              color="success"
              @click="SendQuestionnaireUser"
              class="save"
              type="filled"
            >Send</vs-button>
          </div>
        </vs-popup>
        <vs-popup
          class="holamundo success-popups"
          title="Your registration is complete."
          :active.sync="SuccessQuestionnaire"
        >
          <figure>
            <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
          </figure>
          <h2 class="title">Questionnaire has been sent to {{ selecteduser.userName }}</h2>
          <p>
            You will be notified once the beneficiary completes the
            questionnaire.
          </p>
        </vs-popup>
      </div>
    </div>

    <!-- <vs-popup class="holamundo main-popup"  title="Invite Petitioner" :active.sync="invitepetitioner">      

          <addBenewPet @closenewPetPopup="closenewPetPopup" v-if="invitepetitioner" />
      </vs-popup> -->
      <vs-popup class="holamundo main-popup" title="Invite Client" :active.sync="invitepetitioner">
        <addBenewPet :visatype="visatype" :visasubtype="visasubtype" @closenewPetPopup="closenewPetPopup"
            v-if="invitepetitioner" />
      </vs-popup>
      <!-- <vs-popup class="holamundo main-popup" :class="{'openedNewpetpopup':invitepetitioner}" :title="'Add Beneficiary'" :active.sync="AddBeneficiary">
         <addBeneficiary ref="add_ben" @closeAddBenPopUp="closeAddBenPopUp" v-if="AddBeneficiary"  :petitioner="selectedPetitioner"  @openAddpetPopUp="openAddpetPopUp"/>
      </vs-popup> -->
      <vs-popup class="holamundo main-popup" :class="{ 'openedNewpetpopup': invitepetitioner }"
         :title="'Add Beneficiary'"  :active.sync="AddBeneficiary">
            <addBeneficiary ref="add_ben" @closeAddBenPopUp="closeAddBenPopUp" @fileNewCase="fileNewCase" :visatype="visatype"
                  :visasubtype="visasubtype" v-if="AddBeneficiary" 
                @openAddpetPopUp="openAddpetPopUp" @openAddSponserPopUp="openAddSponserPopUp" :fromSponsorLogin="true"/>
      </vs-popup>
      <vs-popup class="holamundo main-popup" title="Invite Sponsor" :active.sync="inviteSponser">
      <inviteSponser :visatype="visatype" :visasubtype="visasubtype" :fromList="'fromIndBeneLog'"
        @closenewSponserPopup="closenewSponserPopup" v-if="inviteSponser" />
      </vs-popup>
      <!-----archiveAction(false)-->
           <modal
            name="conformArchivemodal"
            classes="v-modal-sec"
            :min-width="200"
            :min-height="200"
            :scrollable="true"
            :reset="true"
            width="450px"
            height="auto"
          >
          <div class="v-modal">
            <div class="popup-header fromDetailsPage">
              <h2 class="popup-title">
              Delete
              
              </h2>
              <span @click="$modal.hide('conformArchivemodal');">
                <em class="material-icons">close</em>
              </span>
            </div>

            <div class="form-container">
        
        <div class="vx-row">
          <div class="vx-col w-full">
          <p class="msg_text">Are you sure to continue?</p>
            
          </div>
          
        </div>

         <div v-show="formerrors.msg">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
       
            </div>
      <div class="popup-footer relative">
      <figure v-if="archiving" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
        <vs-button color="dark" class="cancel" type="filled" @click="$modal.hide('conformArchivemodal');">No </vs-button>
        <vs-button :disabled="archiving" color="success" class="save" type="filled" @click="archiveAction()">Yes</vs-button>
      </div>

          </div>
          </modal>
          <modal
        name="newCaseCreationModal"
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="750px"
        height="auto"
        >
        <div class="v-modal">
        <div class="popup-header fromDetailsPage"> 
        <h2 class="popup-title">
          New Case
        </h2>
        <span @click="$modal.hide('newCaseCreationModal');NewPetition=false;formerrors.msg=''">
          <em class="material-icons">close</em>
        </span>
        </div>
        <form @submit.prevent data-vv-scope="newpetitionform">
        <div class="form-container errorScroll">
          <div class="vx-row" @keyup="formerrors.msg=''" @click="formerrors.msg='';sponsorError = ''">
             <template>
              <div class="vx-col" :class="{'w-full':getTenantTypeId ==2 ,'w-1/2':!( getTenantTypeId ==2)}">
                <div class="form_group">
                  <div class="con-select w-full select-large">
                    <label for="" class="form_label">Case Type<em>*</em></label>
                      <multiselect name="visatype" data-vv-as="Case Type" v-validate="'required'" v-model="visatype"
                          :show-labels="false" track-by="id" label="name" placeholder="Select Case Type" :key="'newpetitionform.visatype'"
                          :options="activeVisatypes" :searchable="true" :allow-empty="false" @input="getvisasubtypes"
                          :disabled="activeVisatypes.length==1">
                      </multiselect>
                  </div>
                  <span class="text-danger text-sm" v-show="errors.has('newpetitionform.visatype')">{{
                        errors.first("newpetitionform.visatype") }}</span>
                </div>
              </div>
              <div class="vx-col " :class="{'w-full':getTenantTypeId ==2 ,'w-1/2':getTenantTypeId !=2}">
                <div class="form_group">
                  <div class="con-select w-full select-large">
                    <label for="" class="form_label">Case Subtype<em>*</em></label>
                    <multiselect name="visasubtype" data-vv-as="Case Subtype" v-validate="'required'"
                          v-model="visasubtype" :show-labels="false" track-by="id" label="name"
                          placeholder="Select Case Subtype" :options="visasubtypes" :searchable="true"
                          :allow-empty="false" @input="checkBenPermStatus"   >
                          <!-- :disabled="visasubtypes.length==1" -->
                        </multiselect>  
                  </div>
                   <span class="text-danger text-sm" v-show="errors.has('newpetitionform.visasubtype')">{{
                        errors.first("newpetitionform.visasubtype") }}</span>
                </div>
              </div>
              <div class="vx-col w-full pp-col"  v-if="[2, 4, 9, 10,11].indexOf(checkProperty(visatype, 'id')) <= -1 && [15, 18].indexOf(checkProperty(visasubtype, 'id')) <= -1">
                <vs-checkbox id="premium" name="premiumProcessing" v-model="premiumProcessing">Premium Processing
                </vs-checkbox>
              </div>
              <div  class="vx-col  w-full">
                <div class="form_group">
                  <div class="con-select w-full select-large">
                    <label for="" class="form_label">Branch<em>*</em></label>
                    <multiselect name="branch" data-vv-as="Branch" v-validate="'required'" v-model="selectedBranch" :show-labels="false"
                      track-by="_id" label="name" placeholder="Select Branch" :options="branchList" :searchable="true"  :key="'newpetitionform_branch'"
                      :allow-empty="false" :multiple="false" :disabled="(branchList.length==1 &&  checkProperty(selectedBranch ,'_id') !='')"
                      @input="formerrors.msg=''">
                    </multiselect>
                  </div>
                  <span class="text-danger text-sm" v-show="errors.has('newpetitionform.branch')">{{
                    errors.first("newpetitionform.branch") }}</span>
                </div>
              </div>
            </template>
            <template>
                  <template v-if="( getTenantTypeId !=2 )">
                    <div class="vx-col" :class="{ 'w-full': getTenantTypeId == 2, 'w-1/2': !(getTenantTypeId == 2) }" v-if="!IsSponsorLogin && (!IsIndBeneficairyLogin && checkProperty(visasubtype, 'id') != 18 && [2,11].indexOf(checkProperty(visatype, 'id')) <= -1   && checkProperty(visasubtype, 'id') != 19)">
                      <div class="form_group">
                        <div class="con-select w-full select-large">
                          <label class="form_label">Select Petitioner<em>*</em></label>
                          <multiselect v-model="selectedPetitioner" :options="petitionersList" :multiple="false"
                            :hideSelected="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                            :select-label="'Search Petitioner'" placeholder="Select Petitioner" label="name" track-by="name"
                            :preselect-first="false" data-vv-as="Petitioner" v-validate="'required'" :key="'newpetitionform_Petitioner'"
                            tag-placeholder="Invite Petitioner" :taggable="false" @tag="addNewPet" :searchable="true"
                            @search-change="searchPet" @input="petitionerUpdated" name="Petitioner">

                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                        </div>
                        <span class="text-danger text-sm" v-show="errors.has('newpetitionform.Petitioner')">{{
                          errors.first("newpetitionform.Petitioner") }}</span>
                      </div>
                      <p  class="createnew marb15">Not found?<span @click="addNewPet()">Invite
                          Customer</span> </p>
                    </div>
                    <div class="vx-col" :class="{ 'w-full': getTenantTypeId == 2, 'w-1/2': !(getTenantTypeId == 2) }"
                        v-if="(checkProperty(visasubtype, 'id') == 18||checkProperty(visasubtype, 'id') == 19) && !IsSponsorLogin && IsIndBeneficairyLogin">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                      <label class="form_label">Select Sponsor<em>*</em></label>

                      <multiselect v-model="sponsor" :options="sponsorList" :multiple="false" :hideSelected="false"  :key="'newpetitionform_selectSponsor'"
                        :close-on-select="true" :clear-on-select="false" :preserve-search="true" :select-label="'sponsor'"
                        placeholder="Sponsor" label="name" track-by="name" :preselect-first="false" data-vv-as="Sponsor"
                        :v-validate="checkProperty(visatype, 'id') == 4 && checkProperty(visasubtype, 'id') == 18 && [50].indexOf(getUserRoleId) <= -1 ? 'required' : ''"
                        :searchable="true" @search-change="searchspnsr" name="selectSponsor" @input="sponsorUpdated"
                        tag-placeholder="sponsor" :taggable="false" @tag="addNewSpr">
                      </multiselect>
                    </div>
                    <span class="text-danger text-sm"
                      v-if="errors.has('newpetitionform.selectSponsor')">{{ errors.first("newpetitionform.selectSponsor")
                      }}</span>
                    <span class="text-danger text-sm" v-else-if="sponsorError">{{ sponsorError }}</span>

                  </div>
                  <p class="createnew marb15">Not found?<span @click="sponsorError = ''; addNewSpr()">Invite
                      Sponsor</span> </p>
                    </div>
                    <div class="vx-col w-1/2" :class="{'w-full':[50 ].indexOf(getUserRoleId)>-1 }" v-if="IsSponsorLogin">
                      <div class="form_group">
                        <div class="con-select w-full select-large">
                          <label class="form_label">Select Beneficiary<em>*</em></label>
                          <multiselect v-model="selectedBeneficiary" :options="beneficiaryMasterDataList"
                            :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                            :preserve-search="true" :select-label="'Search Beneficiary'"
                            :placeholder="'Select Beneficiary'" label="name" track-by="name" :preselect-first="false"
                            :data-vv-as="'Beneficiary'" v-validate="'required'" :searchable="true"
                            @search-change="getbeneficiaryMasterDataList" name="beneficiary" @input="upDateBenef"
                            :tag-placeholder="'Add New Beneficiary'" :taggable="false" @tag="addNewBenFromTag"
                            >

                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                        </div>

                        <span class="text-danger text-sm" v-show="errors.has('newpetitionform.beneficiary')">{{
                          errors.first("newpetitionform.beneficiary") }}</span>

                      </div>
                      <p  class="createnew"
                        >Not found? <span @click="AddBeneficiary =true;selectedBeneficiary=null">Invite Beneficiary</span>
                      </p>
                    </div>
                    <div class="vx-col  w-full"
                      :class="{ 'w-full': [50].indexOf(getUserRoleId) > -1 }"
                      v-if="checkProperty(visatype, 'id') == 2 && !IsSponsorLogin && IsIndBeneficairyLogin && false">
                      <div class="form_group">
                        <div class="con-select w-full select-large">
                          <label class="form_label">Select Beneficiary <em>*</em></label>
                          <multiselect v-model="selectedBeneficiary" :options="beneficiaryMasterDataList"
                            :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                            :preserve-search="true"
                            :select-label="[2].indexOf(checkProperty(visatype, 'id')) > -1 ? 'Search Beneficiary ' : 'Search Beneficiary'"
                            :placeholder="[2].indexOf(checkProperty(visatype, 'id')) > -1 ? 'Search by name or email' : 'Select Beneficiary'"
                            label="name" track-by="name" :preselect-first="false"
                            :data-vv-as="[2].indexOf(checkProperty(visatype, 'id')) > -1 ? 'Beneficiary' : 'Beneficiary'"
                            v-validate="'required'" :searchable="true" @search-change="getBeneficiarySearch"
                            name="beneficiary" @input="upDateBenef"
                            :tag-placeholder="[2].indexOf(checkProperty(visatype, 'id')) > -1 ? 'Add New Beneficiary ' : 'Add New Beneficiary'"
                            :taggable="false" @tag="addNewBenFromTag"
                            >

                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                        </div>

                        <span class="text-danger text-sm" v-show="errors.has('newpetitionform.beneficiary')">{{
                          errors.first("newpetitionform.beneficiary") }}</span>

                      </div>

                      <p
                        class="createnew marb15">Not found? <span @click="AddBeneficiary = true; selectedBeneficiary = null">
                          <template v-if="[2].indexOf(checkProperty(visatype, 'id')) > -1">Invite Beneficiary</template>
                          <template v-else>Invite Beneficiary</template>
                        </span>
                      </p>
                    </div>
                  </template>
                  <template
                v-if="docI130Required  && checkProperty(visatype, 'id') == 4 && checkProperty(visasubtype, 'id') == 19">
                <div class="vx-col w-full" @click="value = []">
                  <div class="form_group file_group">
                    <div class="vs-component marb20">
                      <label class="form_label">I-130 Documents<em>*</em></label>
                      <div class="relative">
                        <file-upload v-model="value" class="file-upload-input upload_file justify-center"
                          :accept="allDocEntity" :name="'documents'" :multiple="true" :fieldName="'i130Docs'"
                          :cid="'i130Docs'" :emitCategory="'i130Docs'" @updateData="updateData"
                          :hideSelected="true">
                          <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                          Upload
                        </file-upload>
                        <span v-if="uploading" class="loader"><img src="@/assets/images/main/loader.gif" /></span>
                      </div>
                      <input type="hidden" :name="'i130Docs'" v-validate="'required'" data-vv-as="130 Documents"
                        v-model="i130Docs">
                      <span class="text-danger text-sm" v-show="errors.has('newpetitionform.i130Docs')">*I-130
                        Documents are required</span>

                    </div>


                    <ul class="uploaded-list note_uploads">
                      <template v-for="(item, index) in i130Docs">
                        <vs-chip @click="remove(item, i130Docs, index)" :key="index" closable>
                          {{ item.name }}
                        </vs-chip>
                      </template>
                    </ul>
                  </div>
                </div>
              </template>
                  <template v-if="[2,11].indexOf(checkProperty(visatype, 'id')) > -1 && [50].indexOf(getUserRoleId) <= -1">
                    <div class="vx-col w-full mb-4">
                      <div class="d-flex align-center">
                        <p class="createnew mr-5">Can {{[11].indexOf(checkProperty(visatype, 'id')) > -1?'L1':'H-1B' }} Employer Company access this case?</p>
                        <div class="custom-radio custom-radio_btns">

                          <vs-radio :name="'isPetitionerAccess'" class="mr-6" :class="{ 'active': isPetitionerAccess == true }"
                            v-model="isPetitionerAccess" @input="selectedPetitioner = null; resetValidator();"
                            :vs-value="true">Yes</vs-radio>
                          <vs-radio :name="'isPetitionerAccess'" v-model="isPetitionerAccess"
                            :class="{ 'active': isPetitionerAccess == false }" :vs-value="false"
                            @input="selectedPetitioner = null; resetValidator();">No</vs-radio>
                        </div>
                      </div>
                    </div>
                    <!-- @input="getIndividualList(true)" -->

                  </template>
                  <div class="vx-col w-full"
                    v-if="( ([2,11].indexOf(checkProperty(visatype, 'id')) > -1 && isPetitionerAccess))">
                    <div class="form_group">

                      <div class="con-select w-full select-large">
                        <label class="form_label">Select Petitioner<em>*</em></label>
                        <multiselect v-if="[2,11].indexOf(checkProperty(visatype, 'id')) > -1" v-model="selectedPetitioner"
                          :options="[...petitionersList]" :multiple="false" :hideSelected="false" :close-on-select="true"
                          :clear-on-select="false" :preserve-search="true" :select-label="'Search Petitioner'"
                          placeholder="Select Petitioner" label="name" track-by="name" :preselect-first="false"
                          data-vv-as="Petitioner" v-validate="'required'" tag-placeholder="Invite Petitioner"
                          :taggable="false" @tag="addNewPet" :searchable="true" @search-change="searchPet"
                          @input="resetValidator();getbeneficiaryListForH4Link('',true)" name="h4Petitioner">

                          <template slot="selection" slot-scope="{ values, isOpen }">
                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                              options selected</span>
                            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                          </template>
                        </multiselect>
                      </div>

                      <span class="text-danger text-sm" v-show="errors.has('newpetitionform.h4Petitioner')">{{
                        errors.first("newpetitionform.h4Petitioner") }}</span>
                    </div>
                    <p  class="createnew marb15">Not found?<span @click="addNewPet()">Invite Client</span> </p>
                  </div>
                  <template v-if="[2,11].indexOf(checkProperty(visatype, 'id')) > -1 && [50].indexOf(getUserRoleId) <= -1 && selectedPetitioner && isPetitionerAccess">
                    <div class="vx-col w-full pwd-link"  v-if="selectedPetitioner && isPetitionerAccess">
                    <div class="form_group custom-radio_wrap ">
                      <ul class="custom-radio mb-1">
                        <li>
                          <vs-radio @input="clearPrimaryH1BHolder" :vs-name="'primaryH1BHolder'" :vs-value="'internalCase'" v-model="primaryH1BHolder"
                            class="w-full">Select primary {{[11].indexOf(checkProperty(visatype, 'id')) > -1?'L1 Holder?':'H-1B holder?' }}</vs-radio>
                        </li>
                        <li>
                          <vs-radio @input="clearPrimaryH1BHolder"  :vs-name="'primaryH1BHolder'" :vs-value="'externalCase'"
                            v-model="primaryH1BHolder" class="w-full">Not in the system yet?</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <input type="hidden" :name="'select_PrimaryH1BHolder'" v-validate="'required'" data-vv-as="Field"
                      v-model="primaryH1BHolder">
                    <span class="text-danger text-sm" style="top:46px"
                      v-show="errors.has('newpetitionform.select_PrimaryH1BHolder')">{{ errors.first('newpetitionform.select_PrimaryH1BHolder')
                      }}</span>

                    </div>
                    <div class="vx-col w-full" v-if=" [2,11].indexOf(checkProperty(visatype, 'id')) > -1 && primaryH1BHolder =='internalCase'">
                      <div class="form_group">
                        <div class="con-select w-full select-large">
                          
                          <label class="form_label">Select {{[11].indexOf(checkProperty(visatype, 'id')) > -1?'L1 Holder?':'H-1B holder?' }} <em>*</em></label>
                          <multiselect v-model="selectedBeneficiaryForH4Link" :options="beneficiaryListForH4Link"
                            :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                            :preserve-search="true"
                            :select-label="[11].indexOf(checkProperty(visatype, 'id')) > -1?'Select L1 Holder':'Select H-1B Holder'"
                            :placeholder="[11].indexOf(checkProperty(visatype, 'id')) > -1?'Select L1 Holder':'Select H-1B Holder'"
                            label="name" track-by="name" :preselect-first="false"
                            :data-vv-as="[11].indexOf(checkProperty(visatype, 'id')) > -1?'L1 Holder':'H-1B Holder'"
                            v-validate="'required'" :searchable="true" @search-change="getbeneficiaryListForH4Link"
                            name="selectedBeneficiaryForH4Link" 
                            :tag-placeholder="[11].indexOf(checkProperty(visatype, 'id')) > -1?'Select L1 Holder':'Select H-1B Holder'"
                            :taggable="false" @tag="addNewBenFromTag"
                            :disabled="false"
                            :key="[11].indexOf(checkProperty(visatype, 'id')) > -1?'Select L1 Holder':'Select H-1B Holder'">

                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                        </div>

                        <span class="text-danger text-sm" v-show="errors.has('newpetitionform.selectedBeneficiaryForH4Link')">{{
                          errors.first("newpetitionform.selectedBeneficiaryForH4Link") }}</span>

                      </div>

                      <!-- <p v-if="([2].indexOf(checkProperty(visatype, 'id')) > -1) || (selectedPetitioner && checkBeneficaryInvitePermisions)"
                        class="createnew marb15">Not found? <span @click="AddBeneficiary = true; selectedBeneficiary = null">
                          <template >Invite Beneficiary</template>
                        </span>
                      </p> -->
                    </div>
                  </template>

                  <template v-else-if=" getTenantTypeId ==2">

                    <div class="vx-col " :class="{'w-full':getTenantTypeId ==2 ,'w-1/2':getTenantTypeId !=2}">
                      <div class="form_group">
                        <div class="con-select w-full select-large">
                          <label class="form_label">Select Beneficiary<em>*</em></label>
                          <multiselect v-model="selectedBeneficiary" :options="beneficiaryMasterDataList"
                            :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                            :preserve-search="true" :select-label="'Search Beneficiary'"
                            :placeholder="'Select Beneficiary'" label="name" track-by="name" :preselect-first="false"
                            :data-vv-as="'Beneficiary'" v-validate="'required'" :searchable="true"
                            @search-change="getbeneficiaryMasterDataList" name="beneficiary" @input="upDateBenef"
                            :tag-placeholder="'Add New Beneficiary'" :taggable="false" @tag="addNewBenFromTag"
                            :disabled="((checkProperty(visasubtype, 'id') != 18 && !checkProperty(selectedPetitioner, '_id') && [50].indexOf(getUserRoleId) <= -1) || (checkProperty(visasubtype, 'id') == 18 && !checkProperty(sponsor, '_id') && [50].indexOf(getUserRoleId) <= -1))">

                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>

                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                        </div>

                        <span class="text-danger text-sm" v-show="errors.has('newpetitionform.beneficiary')">{{
                          errors.first("newpetitionform.beneficiary") }}</span>

                      </div>
                      <p class="createnew">Not found?<span @click="AddBeneficiary =true;selectedBeneficiary=null">Invite
                          Beneficiary</span> </p>
                    </div>
                  </template>
                  
                

                  

                  
            </template> 
          </div>


           <div class="text-danger text-sm formerrors custom_margin" v-show="formerrors.msg">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
          
        </div>

        <div class="popup-footer">
          <vs-button color="dark" @click="addNewCase(false);NewPetition=false ;formerrors.msg='';classification=''" class="cancel" type="filled">Cancel
          </vs-button>
          <vs-button color="success" :disabled=" newPetitionFormSubmited||!enableSubmitBtn" @click="fileNewCase"
            class="save" type="filled">Submit</vs-button>
        </div>
      </form>
        </div>
    </modal>
      
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import Paginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker-inv";
import Multiselect from "vue-multiselect-inv";
import JQuery from "jquery";
import NoDataFound from "@/views/common/noData.vue";

import * as _ from "lodash";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import addBeneficiary  from "@/views/common/addBeneficiary.vue" 
import addBenewPet  from "@/views/common/invitePet.vue" 
import moment from 'moment'
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import inviteSponser from "@/views/common/inviteSponser.vue"
import FileUpload from "@/views/FileUpload.vue";
export default {
  props: {
    beneficiaryId:null,
    beneficiaryInfo:null,
    petitionerDetails:null,
    isRfe:{
      type: 'boolean', default:false
    }
  },
  components: {
    addBeneficiary,
    addBenewPet,
    Datepicker,
    DateRangePicker,
    Multiselect,
    Paginate,
    NoDataFound,
    inviteSponser,
    FileUpload
  },
  data: () => ({
    i130Docs:[],
    docI130Required:false,
    selectedBeneficiaryForH4Link:null,
    beneficiaryListForH4Link:[],
    selectedPetitionerForH4Link:null,
    primaryH1BHolder:'',
    sponsorError: '',
    sponsorList:[],
    sponsorBeneficiaryMasterDataList: [],
    inviteSponser: false,
    selectedH4Petitioner: null,
    isPetitionerAccess: false,
    editor: ClassicEditor,
    editorConfig: {
        toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
    },
    caselist:[{_id:true,name:'Active'},{_id:false,name:'Deleted'}],
    selectedDeletedCase:[],
    premiumProcessingList:[{name:'Enabled' ,_id:true },{name:'Disabled' ,_id:false }],
    selectedpremiumProcessing:[],
    premiumProcessing:false,
    newPetitionFormSubmited:false,
    enableSubmitBtn:true,
     formerrors: {
      msg: ""
    },
    selectedBranch:null,
    NewPetition:false,
    petitionersList:[],
    invitepetitioner:false,
    AddBeneficiary:false,
    selectedPetitioner:null,
    saveBenbtn:false,
    selectedUser:'',
    selectedUsername:'',
    beneficiaryMasterDataList:[],
    visatypes:[],
    activeVisatypes:[],
    visasubtypes:[],
    visasubtype:null,
    selectedBeneficiary:null,
    visatype:null,  



    branchList:[],
    selectedBranches:[],
   isListloading:false,
    callFromSerch:false,
    sortKeys:{},
    sortKey:{},
    buttoncol: true,
    ChangePetition: false,
    formerrors: {
      msg: ""
    },
    searchtxt: "",
    query: [],
    selected: [],
    petitioners: [],
    currentuserRole: null,
    selecteduser: {
      petitionId: null,
      userName: null,
      email: null,
      typeName: null,
      subTypeName: null,
      instructions: null
    },
    SendQuestionnaire: false,
    SuccessQuestionnaire: false,
    selected_createdDateRange: ["", ""],
    selected_deadLineDateRange: ["", ""],
    autoApply: "",
    countries: [],
    country_code: 0,
    selected_country_obj: "",
    selected_statusids: [],
    final_selected_statusids: [],
    all_states: [],
    seleted_states: [],
    final_selected_states: [],
    singel_final_selected_state: "",
    all_locations: [],
    seleted_locations: [],
    final_selected_locations: [],
    all_statusids: [],
    selected_statusids: [],
    final_selected_statusids: [],
    page: 1,
    perpage: 25,
    totalpages: 0,

    filter_searchtxt: "",
    visaTypes:[],
    selectedVisaType:null,
    all_subtypes: [],
    selected_subtypes: [],
    final_selected_subtypes: [],

    final_filter_roleIds: [3, 4, 5, 9, 10],
    rolebased_filter: {
      3: { name: "supervisorIds", values: [] },
      4: { name: "paralegalIds", values: [] },
      5: { name: "attorneyIds", values: [] },
      9: { name: "offshoreUserIds", values: [] },
      10: { name: "evidenceSupervisorIds", values: [] }
    },
    users: [],
    selected_users: [],
    final_selected_users: [],
    user_search_value: "",
    roleId: 0,

    all_peritioners: [],
    peritioners_search_value: "",
    selected_peritioners: [],
    final_selected_peritioners: [],

  isListLoading:false,
    sortKeys:{},
    sortKey:{},
    perPeges: [10,25,50,75,100], // [  {name:10 ,perPage:10} , {name:25 ,perPage:25} ,{name:50 ,perPage:50},{name:100 ,perPage:100}],
    selectedForArchiveList:[],
    archiving:false,
    selectedarchive:[],
    selectedAllForArchive:false,
    encodedString:'',
    debounce:null,
    sponsor:null,
   
  }),
  watch: {
    searchtxt: function(value) {
      this.searchMe();
     
    },
     '$route.query.filter':function (val) {

        if(this.checkProperty(this.$route ,'query' ,'filter')){
                try{
                  let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
                  var actual = JSON.parse(atob(filter));
                  let keys = Object.keys(actual);
                  if(this.checkProperty(keys ,'length') >0){


                    if(actual && (Object.keys(actual)).length>0 ){
                    _.forEach(actual ,(item ,key) => {
                        if(key=='matcher' ){
                          
                          if((Object.keys(item)).length>0 ){

                            if(_.has(item ,'typeIds') && this.checkProperty(item , 'typeIds' ,'length')>0 ){
                               
                              this.selectedVisaType = _.find(this.visaTypes ,{"id":item['typeIds'][0]})
                           
                             this.getvisa_subtypes();
                           
                            }

                            
                            
                          }
                        
                        }
                      
                        
                    
                    })
                  }
                    
                    
                  }

                }catch(e){
                  

                }
                  
              }
        
          this.getpetitions(true);
      }
  },
  methods: {
    updateData(docs, category) {
      if (category == 'i130Docs') {
        this.i130Docs = docs
      }
    },
    remove(item, data, filindex) {
      data.splice(filindex, 1);
      this.disablePWDstatus = false;
      this.removeFileFromS3(item)
    },
    clearPrimaryH1BHolder(val){
      if(!val){
        this.selectedBeneficiaryForH4Link = null;
      }
    },
    getbeneficiaryListForH4Link(text = '', callFromPetitioner=false) {
      let postData = {
        "matcher": {
          "title": text,
          "statusList": [],
          "branchIds": [],
          "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          "createdByIds": [],
          "createdDateRange": [],
          "roleIds": [51],
          "statusIds": [],
          "petitionTypeIds": [],
          "petitionSubTypeIds": [],
          "petitionCreatedDateRange": [],
          "petitionStatusIds": [],
          "getPetitionStats": true,
          "getH1bBeneficiaries":true
        },
        "sorting": {
          "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          "order": 1
        },
        "page": 1,
        "perpage": 1000000,
        "getMasterData": true,
        "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        "branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        "companyId": "" // Required when 'getMasterData' is true and roleIds are [50, 51]
      };
      if([11].indexOf(this.checkProperty(this.visatype, 'id')) > -1){
        postData['matcher']['getH1bBeneficiaries'] = false;
        postData['matcher']['getL1Beneficiaries'] = true;
      }
      if (this.checkProperty(this.selectedPetitioner, "_id") && [2,11].indexOf(this.checkProperty(this.visatype, 'id')) > -1) {
        postData['companyId'] = this.selectedPetitioner['_id']
      } else if ([50, 51].indexOf(this.getUserRoleId) > -1 && this.checkProperty(this.getUserData, "companyDetails", "_id")) {
        postData['companyId'] = this.checkProperty(this.getUserData, "companyDetails", "_id")
      } 
      if(callFromPetitioner){
        this.selectedBeneficiaryForH4Link = null;
      }
      this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then(response => {
          let beneficiaryListForH4Link = _.cloneDeep(response.list);
          this.beneficiaryListForH4Link = [];
          _.forEach(beneficiaryListForH4Link, (item) => {
            if (this.checkProperty(item, 'name')) {
              if (this.checkProperty(item, 'email')) {
                item['name'] = item['name'] + " (" + item['email'] + ")"
              }
              this.beneficiaryListForH4Link.push(item);
            }
          })
        })
    },
    searchspnsr(searchText = '') {
      let _self = this;
      this.selectedBeneficiary = null;
      //this.sponsor =null;
      let self = this;
      clearTimeout(self.debounce)
      self.debounce = setTimeout(() => {
        self.getSponserForCase(self, searchText);
      }, 900)
    },
    sponsorUpdated() {
      this.selectedBeneficiary = null;
      this.selectedUser = '';
      this.selectedUsername = '';
      this.getbeneficiaryMasterDataList();
      this.selectedPwdId = null;
      this.isLinkPwd = false;
      if (!this.checkProperty(this.beneficiaryInfo, 'email') && this.checkProperty(this.beneficiaryInfo, 'tempUser') == true) {
        this.hideBeneforQues = false;
        this.fillTheQuestionnire = 'Petitioner'
      }
    },
    getBeneficiarySearch(text = '') {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.getbeneficiaryMasterDataList(text)
      }, 900)
    },
    resetValidator() {
      setTimeout(() => {
        this.$validator.reset();
      }, 50)
    },
    openAddSponserPopUp() {
      this.inviteSponser = true;
    },
    addNewSpr(newPet = '', id) {
      this.inviteSponserPopupShow(true)
    },
    closenewSponserPopup(selectedSponsor = null, type) {
      if(type=='fromIndBeneLog'){
        this.getbeneficiaryMasterDataList();
      }else{
        this.getSponserForCase();
      }
      
      this.sponsor = selectedSponsor;
      this.inviteSponserPopupShow(false);
      this.openNewbenFormPopup(true);
    },
    inviteSponserPopupShow(action = true) {
      this.inviteSponser = action;
      if (!action) {
        this.selectedBeneficiary = null;
      }
    },
    getvisaforNewCase() {
      let item = {
            matcher: {
              getActiveList: true,
            },
            page: this.page,
            perpage: this.perpage,
            category: "petition_types",
          };
        this.visatype = null;
        this.$store.dispatch("getMasterData", item).then(response => {
          if(this.IsSponsorLogin){
              this.activeVisatypes = _.filter(response.list, (item) => {
                return item.id === 4;
              })
              if (this.checkProperty(this.activeVisatypes, 'length') > 0) {
                this.visatype = this.activeVisatypes[0];
                this.getvisasubtypes(this.visatype)
              }
          }
          if(this.IsIndBeneficairyLogin){
              this.activeVisatypes = _.filter(response.list, (item) => {
                return [2,4,11].indexOf(item.id)>-1
                // return item.id === 2 || item.id === 4;
              })
              if (this.checkProperty(this.activeVisatypes, 'length') > 0) {
                this.visatype = this.activeVisatypes[0];
                this.getvisasubtypes(this.visatype)
              }
          }
          
});
},
    checkBenPermStatus() {
      this.category = null;
      this.classification = null;
      this.showForm = false
      this.selectedBeneficiary=null,
      this.docI130Required = false,
      setTimeout(() => {
        this.showForm = true
      })
      if (this.checkProperty(this.visasubtype, 'id') == 18 && !this.IsSponsorLogin) {
        this.getSponserForCase();
      }
      if ((this.checkProperty(this.visasubtype, 'id') == 18||this.checkProperty(this.visasubtype, 'id') == 19) && this.IsSponsorLogin) {
        this.getbeneficiaryMasterDataList();
      }
        this.formerrors.msg = '';
      this.enableSubmitBtn = true;
      this.checkPermStatus()
      
    },
    getSponserForCase(text = '') {
      let postData = {
        "matcher": {
          "title": text,
          "statusList": [],
          "branchIds": [],
          "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          "createdByIds": [],
          "createdDateRange": [],
          "roleIds": [51],
          "statusIds": [],
          "petitionTypeIds": [],
          "petitionSubTypeIds": [],
          "petitionCreatedDateRange": [],
          "petitionStatusIds": [],
          "getPetitionStats": true
        },
        "sorting": {
          "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          "order": 1
        },
        "page": 1,
        "perpage": 1000000,
        "getMasterData": true,
        "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        "branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        "companyId": "" // Required when 'getMasterData' is true and roleIds are [50, 51]
      };
      postData['isIndividual'] = true;
      this.enableAddNewBenTag = false;
      if ([4].indexOf(this.checkProperty(this.visatype, 'id')) > -1 || (this.isPetitioner == false || this.isPetitioner == 'false')) {
        postData['matcher']['accountType'] = 'Individual';
        postData['matcher']['accountSubType'] = 'Sponsor';
      }
      this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then(response => {
          this.sponsorList = response.list;

          let filteredData = [];
          _.forEach(this.sponsorList, (item) => {
            if (item && (_.has(item, 'name') || _.has(item, 'email'))) {

              if ((_.has(item, 'name') && item['name'].includes(text)) || (_.has(item, 'email') && item['email'].includes(text))) {
                filteredData.push(item)
              } else {
                return false;
              }
            } else {
              return false;
            }
          })

          if (filteredData.length <= 0) {
            this.enableAddNewBenTag = true;
          }
          let sponsorList = _.cloneDeep(this.sponsorList);
          this.sponsorList = [];
          _.forEach(sponsorList, (item) => {
            if (this.checkProperty(item, 'name')) {
              if (this.checkProperty(item, 'email')) {
                item['name'] = item['name'] + " (" + item['email'] + ")"
              }
              this.sponsorList.push(item);
            }

          })


        })

    },
    fileNewCase() {
      this.pwdDocFormatError = '';
      this.sponsorError = '';
      this.branchError = '';
      if (this.checkProperty(this.visasubtype, 'id') == 15) {
        this.createNewPerm()
      } else {
        //sponsorError


        this.createNewPetition()
      }

    },
    searchMe(){
      let self =this;
      clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          self.page = 1;
          self.getpetitions(true);
        }, 900)
    },
    selectAllforArchive(){
              this.formerrors.msg ='';
          this.selectedForArchiveList =[];
        _.forEach(this.petitioners ,(item)=>{
          item.selectedForArchive =false;
          if(this.selectedAllForArchive && this.checkProperty(item ,'status')!=false){
             item.selectedForArchive =true;
             this.selectedForArchiveList.push(item._id)

          }
         
        })

      if(this.petitioners.length>0 && this.petitioners.length != this.selectedForArchiveList.length ){
        this.selectedAllForArchive =false;
      }
     
      

    },
    archiveAction(){
       this.formerrors.msg ='';
     let postData ={
       "petitionIds":[]
     };
     postData['petitionIds'] = this.selectedForArchiveList;
     this.archiving =true;
      this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/petition/delete"})
              .then(response => {
               
                this.archiving =false;
                this.selectedForArchiveList =[];
                this.showToster({message:response.message,isError:false });
                this.$modal.hide('conformArchivemodal');
                this.getpetitions();
                                               
                                
              })
              .catch((error)=>{
                 this.formerrors.msg  =error
              //  this.showToster({message:error,isError:true });
                this.archiving =false;
              })

    },

    selectForArchive(caseItem){
       
             this.formerrors.msg ='';
        if(this.archiving ){
         return false
       }else{
         this.archiving =false
       if(this.checkProperty(caseItem ,'selectedForArchive') && this.checkProperty(caseItem ,'status') !=false){
         if(this.selectedForArchiveList.indexOf(caseItem['_id'])<=-1){
            this.selectedForArchiveList.push(caseItem['_id'])

         }

       }else{
          this.selectedForArchiveList = _.filter( this.selectedForArchiveList ,(item)=>{
           return item !=caseItem['_id']
          })
       }

    }
    this.selectedAllForArchive =false
    if(this.petitioners.length==this.selectedForArchiveList.length && this.selectedForArchiveList.length>0){
      this.selectedAllForArchive =true
    }
       

     },
    


    goTodetails(petition , stab ='Communication'){

      this.$store.dispatch("setPetitionTab" , stab)
      this.$router.push("/petition-details/"+petition['_id'])
    },  
    addNewBenFromTag(){

    },
     searchPet(searchText){
          let _self =this;
     
      
      this.selectedBeneficiary =null;
      this.selectedPetitioner =null;
      this.selectedUser ='';
      this.selectedUsername = '';
    
      let filteredData =[];
       _.forEach(_self.petitionersList ,(item)=>{
                if( item && ( _.has(item ,'name') || _.has(item ,'email')  )){

                         if((_.has(item ,'name') && item['name'].includes(searchText)) || (_.has(item ,'email') && item['email'].includes(searchText)) ){
                          filteredData.push(item)
                         }else{
                            return false;
                         }

                }else{
                  return false;
                }
              
           
         })
       if( (filteredData.length<=0 )){

         this.getPetitioners( true , searchText);
       }
         
     },
    addNewPet(newPet='' ,id){
       this.newPetOpenFromben =false;
       this.openNewbenForm =false;
       this.addNewPete =true;
       this.invitePetitionPopupshow(true)
     },
    petitionerUpdated(){
      this.selectedBeneficiary = null;
      this.selectedUser ='';
      this.selectedUsername = '';
      this.getbeneficiaryMasterDataList();
    },

     getvisatypes(){
      this.$store.dispatch("getvisatypes").then(response => {
        this.visatypes = response;
      });
    },
    getvisasubtypes(vsType){
      
     Object.assign(this.formerrors , {msg:''});
     this.isPetitionerAccess = false
    if(this.visatype && _.has(this.visatype ,"id")){
        this.visasubtypes =[];
        this.visasubtype = null;
        let item ={
          matcher:{
             "petitionType":parseInt(this.visatype['id'])
          },   
          page:this.page,
          perpage: this.perpage,
          category: "petition_sub_types",
        };
      

        this.$store.dispatch("getMasterData", item).then(response => {
          if(this.IsSponsorLogin){
              this.visasubtypes = _.filter(response.list, (item) => {
                return item.id === 18||item.id === 19;
              })
          }
          if(this.IsIndBeneficairyLogin){
              this.visasubtypes = _.filter(response.list, (item) => {
                return item
              })
          }
        });
        if (this.checkProperty(this.visasubtypes, 'length') > 0) {
          this.visasubtype = this.visasubtypes[0];
        }
        this.$validator.reset();
        }
        if(this.checkProperty(this.visatype, "id") == 4) {
        this.getSponserForCase();
      }
    },

   createNewPetition(errorCode=''){
      Object.assign(this.formerrors, {
                  msg: ''
                })
            this.$validator.validateAll('newpetitionform').then(result => {
              if (this.checkProperty(this.visatype, 'id') == 4 && (this.checkProperty(this.visasubtype, 'id') == 18||this.checkProperty(this.visasubtype, 'id') == 19) && this.IsIndBeneficairyLogin) {
                  if (!this.checkProperty(this.sponsor, "_id")) {
                    this.sponsorError = '*Sponsor is Required';
                    return false;
                  }
              }
              if([2,11].indexOf(this.checkProperty(this.visatype, 'id'))>-1){
                this.premiumProcessing = false;
              }
        if (result) {
          let self =this;
      var postdata ={
        type: this.visatype.id,
        userId:this.selectedUser,
        userName:this.selectedUsername,
        typeName:this.visatype.name,
        subType:this.visasubtype.id,
        subTypeName:this.visasubtype.name,
        petitionerId:null,
        premiumProcessing:this.premiumProcessing,
        branchId:'',
        today: moment().format('YYYY-MM-DD'),
       
      };
      if (this.checkProperty(this.visatype, 'id') == 4 && this.checkProperty(this.visasubtype, 'id') == 19 &&
            this.checkProperty(this.i130Docs, 'length') > 0) {
            postdata['i130Id'] = this.responsei130Id
            postdata['i130Docs'] = this.i130Docs
          }
      if (this.getTenantTypeId != 2 && this.checkProperty(this.visatype, 'id') == 4 && this.checkProperty(this.visasubtype, 'id') == 18) {
          postdata['petitionerId'] = this.checkProperty(this.sponsor, "_id")
          postdata['fillTheQuestionnire'] = this.fillTheQuestionnire
      }
      if(errorCode && this.caseErrorCode){
        if(errorCode == 'true'){
          postdata['replaceDefaultUser'] = true
        }
        else{
          postdata['replaceDefaultUser'] = false
        }
      }
      if(this.getTenantTypeId !=2){
        if([50].indexOf(this.getUserRoleId) > -1){
           postdata['petitionerId'] = this.$store.state.user._id
        }
        else{
           postdata['petitionerId'] = this.checkProperty(this.selectedPetitioner ,"userId")
        }
        

      }

      if(this.checkProperty(this.beneficiaryInfo ,"name") && this.beneficiaryId){
        postdata['userId'] = this.beneficiaryId;
        postdata['userName'] =this.beneficiaryInfo['name']
      }
      if(this.getTenantTypeId != 2 && this.checkProperty(this.visatype, 'id') == 4 && (this.checkProperty(this.visasubtype, 'id') == 18||this.checkProperty(this.visasubtype, 'id') == 19) && this.IsSponsorLogin ){
          postdata['petitionerId'] = this.$store.state.loginUserData.userId ;
          postdata['fillTheQuestionnire'] = "Petitioner";
      }
      if(this.getTenantTypeId != 2 && this.checkProperty(this.visatype, 'id') == 4 && (this.checkProperty(this.visasubtype, 'id') == 18||this.checkProperty(this.visasubtype, 'id') == 19) && this.IsIndBeneficairyLogin && this.checkProperty(this.sponsor, "_id")){
          postdata['petitionerId'] =this.checkProperty(this.sponsor, "_id");
          postdata['fillTheQuestionnire'] = "Beneficiary";
      }
      if(this.getTenantTypeId != 2 && this.checkProperty(this.visatype, 'id') == 4 && (this.checkProperty(this.visasubtype, 'id') == 18||this.checkProperty(this.visasubtype, 'id') == 19) && this.IsIndBeneficairyLogin){
          postdata['userId'] = this.$store.state.loginUserData.userId;
          postdata['userName'] = this.$store.state.loginUserData.userName;
      }
      if(this.getTenantTypeId != 2 && [2,11].indexOf(this.checkProperty(this.visatype, 'id'))>-1 && this.IsIndBeneficairyLogin){
          postdata['userId'] = this.$store.state.loginUserData.userId;
          postdata['userName'] = this.$store.state.loginUserData.userName;
      }
      
      if(this.selectedBranch && _.has(this.selectedBranch ,"_id")){
        postdata['branchId'] =this.selectedBranch['_id']
      }
      if(this.checkProperty(this.visatype, 'id') == 2){
        postdata['primaryH1BHolder'] = this.primaryH1BHolder;
        if(this.primaryH1BHolder =='internalCase' && this.checkProperty(this.selectedBeneficiaryForH4Link, '_id')){
          postdata['h1bBeneficiaryId'] = this.checkProperty(this.selectedBeneficiaryForH4Link, '_id');
        }
        
      }
      if(this.checkProperty(this.visatype, 'id') == 11){
        postdata['primaryL1Holder'] = this.primaryH1BHolder;
        if(this.primaryH1BHolder =='internalCase' && this.checkProperty(this.selectedBeneficiaryForH4Link, '_id')){
          postdata['l1BeneficiaryId'] = this.checkProperty(this.selectedBeneficiaryForH4Link, '_id');
        }
        
      }
      this.$modal.hide('errorConfirmationModal');
      if(!this.newPetitionFormSubmited){
        this.newPetitionFormSubmited =true;
       /// console.log('brnr payload',JSON.stringify(postdata))
        this.$store.dispatch("petitioner/createnewpetition", postdata)
        .then(response => {
              this.premiumProcessing = false;
                 if (response.error) {
                Object.assign(this.formerrors, {
                  msg: response.error.message
                });
                this.newPetitionFormSubmited =false;
              } else {
                this.caseErrorDetails = null
                this.caseErrorCode = ''
                this.caseCreationErrMsg = ''
                   let dt ={
                  petitionId: response._id,
                  userName: this.selectedUsername,
                  email: this.selectedUseremail,
                  typeName: this.visatype.name,
                  subTypeName: this.visasubtype.id,
                  instructions: null
                }
                      
                        this.NewPetition =false; 
                         this.newPetitionFormSubmited =false;
                         this.getpetitions();
                      //this.$vs.notify({title: "Success",text: response.message });

                        // this.visatype = {
                        // id: 1,
                        // name: "H-1B"
                        // }
                        // this.getvisasubtypes(this.visatype);
                        this.getvisaforNewCase();
                       this.showToster({message:response.message ,isError:false});
                       this.addNewCase(false);
                       setTimeout(()=>{

                        if (postdata.subType == 15) {
                      this.$router.push({ name: 'gc-employment-details', params: { itemId: response._id } }).catch(err => { })


                    } else {

                      if (self.checkProperty(self.selectedBeneficiary, "anonymousUser")) {
                        this.goto(response._id);
                      } else {
                        this.goto(response._id);
                        // this.clear_filter();

                      }

                    }
                       
                          
                           
                       } ,10)

                      
                     
              }

        })
        .catch((error)=>{
          //this.showToster({message:error,isError:true});
          let errorr = error.result.error
          this.caseErrorCode = '';
          //this.showToster({message:error,isError:true}); 
          this.newPetitionFormSubmited =false;
          if(_.has(errorr,'code') && this.checkProperty(errorr,'code')){
            this.caseErrorCode = this.checkProperty(errorr,'code')
            this.caseCreationErrMsg = this.checkProperty(errorr,'message')
            this.$modal.show('errorConfirmationModal');
            this.caseErrorDetails ={
              subType:this.visasubtype.id
            }
          }
          else{
            Object.assign(this.formerrors, {
              msg: errorr.message
            });
          }  
        });

      }
      
      
        }else{
          const $ = JQuery;
             if($('.errorScroll .text-danger:visible')){
                var _t = $('.errorScroll .text-danger:visible').first().parent().offset().top;
                if(_t < 0) _t = -(_t)
                  $('.scrollable:visible').scrollTop(_t-50);
                }
             }
        
});
    },
    addNewCase(action=true){
      this.NewPetition =action;
      this.sponsorError = '';
      let self =this;
      // if(action){
      //   this.getvisaforNewCase();
      // }
      this.docI130Required = false;
      this.visasubtype=null
      this.selectedBeneficiary =null;
      this.selectedBeneficiaryForH4Link = null;
      this.beneficiaryListForH4Link = [];
      this.primaryH1BHolder = '';
      if(this.checkProperty(this.petitionerDetails ,'_id')){
        this.selectedPetitioner = this.petitionerDetails;
        this.selectedPetitioner =  Object.assign(this.selectedPetitioner ,{"userId":self.petitionerDetails['_id']})
      }
      if([50].indexOf(this.getUserRoleId) >-1){
       
        let userId =  this.checkProperty((this.getUserData ,'companyDetails' ,"_id"))
        let name =  this.checkProperty((this.getUserData ,'companyDetails',"name"))
        this.selectedPetitioner ={}
        this.selectedPetitioner  =  Object.assign(this.selectedPetitioner ,{"_id":userId})
        this.selectedPetitioner =  Object.assign(this.selectedPetitioner ,{"name":name})
         this.selectedBeneficiary =null;
          //this.getbeneficiaryMasterDataList();
         
      }
      if (this.NewPetition) {
        this.getPetitioners();
        this.$modal.show('newCaseCreationModal');

      } else {
        this.$modal.hide('newCaseCreationModal');
        //hide 
      }
      
      this.$validator.reset();

    },
    openAddpetPopUp(){
     
      this.selectedPetitioner =null;
      this.invitepetitioner =true;
    },
    closenewPetPopup(selectedPetitioner=null){

   
       
      this.getPetitioners();
       this.selectedPetitioner =selectedPetitioner;
       this.invitePetitionPopupshow(false);
       if ([2,11].indexOf(this.checkProperty(this.visatype, 'id'))<=-1) {
        this.openNewbenFormPopup(true);
      }
      if([2,11].indexOf(this.checkProperty(this.visatype, 'id'))>-1 && selectedPetitioner && selectedPetitioner != null){
        this.selectedBeneficiaryForH4Link = null;
        this.beneficiaryListForH4Link = [];
      }

    },
    upDateBenef(){
      if(this.checkProperty(this.selectedBeneficiary ,'name') && this.checkProperty(this.selectedBeneficiary ,'_id') ){
        this.selectedUser =this.checkProperty(this.selectedBeneficiary ,'_id');
        this.selectedUsername = this.checkProperty(this.selectedBeneficiary ,'name');
     }
     this.checkPermStatus()
    },
    checkPermStatus() {
     // console.log("this.beneficiaryId",this.beneficiaryId)
      //485 case type
      if (this.checkProperty(this.visatype, 'id') == 4 && this.checkProperty(this.visasubtype, 'id') == 19 && (this.checkProperty(this.selectedBeneficiary, '_id')||this.IsIndBeneficairyLogin)) {
        this.i130Docs = [];
        this.docI130Required = false,
        this.formerrors.msg = '';
        this.enableSubmitBtn = true;
        let postData = {
          userId: this.checkProperty(this.selectedBeneficiary, '_id'),
          type: this.checkProperty(this.visatype, 'id'),
          subType: this.checkProperty(this.visasubtype, 'id'),
        }
        if(this.checkProperty(this.selectedBeneficiary, '_id')){
          postData['userId'] = this.checkProperty(this.selectedBeneficiary, '_id');
        }else if(this.IsIndBeneficairyLogin){
          postData['userId'] = this.$store.state.loginUserData.userId;
        }
        this.$store.dispatch('commonAction', { "data": postData, "path": "/petition/get-i140-filed-docs" })
          .then((response) => {
            let responseData = response;

            if (this.checkProperty(responseData, 'code') == "REQUIRED_DOCS") {
              this.docI130Required = true;
              this.enableSubmitBtn = true;
            }
            else {
              if (this.checkProperty(responseData, 'i130Id')) {
                if (this.checkProperty(responseData, 'i130Docs', 'length') > 0) {
                  this.responsei130Id = this.checkProperty(responseData, 'i130Id')
                  this.i130Docs = this.checkProperty(responseData, 'i130Docs');
                  this.enableSubmitBtn = true;
                }
                else {
                  this.formerrors.msg = "Unable to create the I-485 Case";
                  this.enableSubmitBtn = false;
                }
              }
              else {
                this.formerrors.msg = "Unable to create the I-485 Case";
                this.enableSubmitBtn = false;
              }
            }
          }).catch((error) => {
            this.formerrors.msg = error;
            this.enableSubmitBtn = false;

          })

      }
    },
   closeAddBenPopUp(selectedBeneficiary=null){
     
      this.AddBeneficiary =false;
     this.selectedBeneficiary =selectedBeneficiary;
     if(this.checkProperty(this.selectedBeneficiary ,'name') && this.checkProperty(this.selectedBeneficiary ,'_id') ){
        this.selectedUser =this.checkProperty(this.selectedBeneficiary ,'_id');
        this.selectedUsername = this.checkProperty(this.selectedBeneficiary ,'name');
     }
  
     this.getbeneficiaryMasterDataList();
   },
   getPetitioners(callFromSerch=false,searchText='' ) {
      
       
        let _self =this;
        if(this.callFromSerch){
         
         // this.petitionersList =[];
        }
        let query ={
          "matcher":{
            "searchString": searchText,
            "statusIds": [],
            "countryIds": [],
            "stateIds": [],
            "locationIds": [],
            "createdDateRange": []
          },
        "sorting": { 	"path": "createdOn", 	"order": 1 	},
        "page": 1,
        "perpage": 100,
        getMasterData:true
	}
       
      
        this.$store
          .dispatch("getList",{data:query ,path:'/company/list'} )
          .then(response => {
            
            _self.petitionersList = response.list;

            let filteredData =  _.filter(_self.petitionersList ,(item)=>{
                if( item&& ( _.has(item ,'name') || _.has(item ,'email')  )){

                         if((_.has(item ,'name')&& item['name'].includes(searchText)) || (_.has(item ,'email') && item['email'].includes(searchText)) ){
                           return true;
                         }else{
                            return false;
                         }

                }else{
                  return false;
                }
              
           
         })
       
                   
            //alert(this.perpage);
          }).catch((err)=>{
            this.petitionersList =[];
          })
   },
   invitePetitionPopupshow(action =true){
     this.invitepetitioner=action;
      
      
     },
      openNewbenFormPopup(action =false){
       this.saveBenbtn =false;
       if(action==true){
         this.invitePetitionPopupshow(false);
       }
       if(action){
       
          
         if(this.checkProperty(this.selectedPetitioner ,'userId')){
         
           this.AddBeneficiary =true;
          
            try{
              setTimeout(()=>{
                this.$refs['add_ben'].setPetDetails(this.selectedPetitioner)

              } ,50)
            }catch(e){}
          }else{
           
             this.AddBeneficiary =false;
          }

       }else{
          this.AddBeneficiary =action;

       }
       
      
       
       this.$validator.reset();
     },
     getbeneficiaryMasterDataList(tex = '') {
      let text = tex.trim();
      let postData = {
        "matcher": {
          "title": text,
          "statusList": [],
          "branchIds": [],
          "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          "createdByIds": [],
          "createdDateRange": [],
          "roleIds": [51],
          "statusIds": [],
          "petitionTypeIds": [],
          "petitionSubTypeIds": [],
          "petitionCreatedDateRange": [],
          "petitionStatusIds": [],
          "getPetitionStats": true
        },
        "sorting": {
          "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          "order": 1
        },
        "page": 1,
        "perpage": 1000000,
        "getMasterData": true,
        "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        "branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        "companyId": "" // Required when 'getMasterData' is true and roleIds are [50, 51]
      };

      this.enableAddNewBenTag = false;
      //this.$store.state.loginUserData
      if(this.IsSponsorLogin){
        postData['companyId'] = this.$store.state.loginUserData.userId
        postData['matcher']['accountType'] = 'Individual';
        postData['matcher']['accountSubType'] = 'Beneficiary';
      }
      if(this.IsIndBeneficairyLogin && [2,11].indexOf(this.checkProperty(this.visatype, "id"))>-1){
        postData['companyId'] = ''
        postData['matcher']['accountType'] = 'Individual';
        postData['matcher']['accountSubType'] = 'Beneficiary';
      }
      if(this.IsIndBeneficairyLogin && this.checkProperty(this.visatype, "id") == 4 ){
        postData['companyId'] = ''
        postData['matcher']['accountType'] = 'Individual';
        postData['matcher']['accountSubType'] = 'Sponsor';
      }
      // if (this.checkProperty(this.selectedPetitioner, "_id") && this.checkProperty(this.visatype, "id") != 2) {
      //   postData['companyId'] = this.selectedPetitioner['_id']
      // } else if ([50, 51].indexOf(this.getUserRoleId) > -1 && this.checkProperty(this.getUserData, "companyDetails", "_id")) {
      //   postData['companyId'] = this.checkProperty(this.getUserData, "companyDetails", "_id")
      // } else {
      //   postData['matcher']['accountType'] = 'Individual';
      //   postData['matcher']['accountSubType'] = 'Beneficiary';
      // }


      // if ([2, 10].indexOf(this.checkProperty(this.visatype, 'id')) > -1 || (this.isPetitioner == false || this.isPetitioner == 'false')) {
      //   postData['matcher']['accountType'] = 'Individual';
      //   postData['matcher']['accountSubType'] = 'Beneficiary';
      //   // postData['companyId'] = '';
      // }
      // if ([4].indexOf(this.checkProperty(this.visatype, 'id')) > -1 && [18].indexOf(this.checkProperty(this.visasubtype, 'id')) > -1 && this.checkProperty(this.sponsor, "_id") && this.IsSponsorLogin) {
      //   postData['companyId'] = this.sponsor['_id']
      //   postData['matcher']['accountType'] = 'Individual';
      //   postData['matcher']['accountSubType'] = 'Beneficiary';
      // }
      // if ([4].indexOf(this.checkProperty(this.visatype, 'id')) > -1 && [18].indexOf(this.checkProperty(this.visasubtype, 'id')) > -1 && !this.checkProperty(this.sponsor, "_id")) {
      //   postData['companyId'] = this.selectedPetitioner['_id']
      //   postData['matcher']['accountType'] = 'Individual';
      //   postData['matcher']['accountSubType'] = 'Sponsor';
      // }

      //this.beneficiaryMasterDataList =[];
      if ([2,11].indexOf(this.checkProperty(this.visatype, "id"))>-1 && this.checkProperty(text, 'length') == 0) {
        this.beneficiaryMasterDataList = []
        return
      }
      postData['isIndividual'] = true;
      this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then(response => {
          this.beneficiaryMasterDataList = response.list;

          let filteredData = [];
          _.forEach(this.beneficiaryMasterDataList, (item) => {
            if (item && (_.has(item, 'name') || _.has(item, 'email'))) {

              if ((_.has(item, 'name') && item['name'].includes(text)) || (_.has(item, 'email') && item['email'].includes(text))) {
                filteredData.push(item)
              } else {
                return false;
              }

            } else {
              return false;
            }


          })

          if (filteredData.length <= 0) {
            this.enableAddNewBenTag = true;
          }
          let beneficiaryMasterDataList = _.cloneDeep(this.beneficiaryMasterDataList);
          //this.sponsorBeneficiaryMasterDataList = _.cloneDeep(this.beneficiaryMasterDataList);
          this.beneficiaryMasterDataList = [];

          _.forEach(beneficiaryMasterDataList, (item) => {
            if (this.checkProperty(item, 'name')) {
              if (this.checkProperty(item, 'email')) {
                item['name'] = item['name'] + " (" + item['email'] + ")"
              }
              this.beneficiaryMasterDataList.push(item);

              this.sponsorBeneficiaryMasterDataList.push(item);
            }

          })


        })

    },
     getpetitions(callFromSerch=false){
      this.callFromSerch = callFromSerch;
      let self =this;
     // if(this.callFromSerch){
         
          this.petitioners  =[];
        //}
      let postData = {
          "matcher": {
            "title": self.searchtxt,
            "statusList": [],
            "branchIds": [],
            "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
            "createdByIds": [],
            "createdDateRange": [],
            "roleIds": [51],
            "statusIds": [],
            "petitionTypeIds": [],
            "petitionSubTypeIds": [],
            "petitionCreatedDateRange": [],
            "petitionStatusIds": [],
            "petitionIntStatusIds":[1],
            "getPetitionStats": true,
           
            statusList:false
          },
        "sorting": {
          "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
          "order": 1
        },
        "page": 1,
        "perpage": 1000000,
        //"getMasterData": true,
        "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
        //"branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
        //"companyId": "" // Required when 'getMasterData' is true and roleIds are [50, 51]
	    };
      if(this.$router.currentRoute && this.$router.currentRoute.path && this.$router.currentRoute.path =='/ref-cases' ){
        postData['matcher']['petitionTypeIds'] = [9]
      }else{
        postData['matcher']['petitionTypeIds'] = [];
      }
  if(this.checkProperty( this.selectedDeletedCase ,"length")>0){
    postData['matcher']['petitionStatusList'] = this.selectedDeletedCase.map((item)=>item._id)

  }
  let loginData = this.$store.state.loginUserData;
if(this.checkProperty(loginData,'accountType') && this.checkProperty(loginData,'accountType')=='Individual' && 
this.checkProperty(loginData,'accountSubType') && this.checkProperty(loginData,'accountSubType')=='Beneficiary'
){
  postData['matcher']['beneficiaryType']= "beneficiary"
    
  }
  if(this.checkProperty(loginData,'accountType') && this.checkProperty(loginData,'accountType')=='Individual' && 
    this.checkProperty(loginData,'accountSubType') && this.checkProperty(loginData,'accountSubType')=='Sponsor'){
    postData['matcher']['accountType']= "Individual"
     postData['matcher']['accountSubType']= "Sponsor"
  }
  this.enableAddNewBenTag =false;
  //   if(this.checkProperty(this.selectedPetitioner ,"_id")){

  //     postData['companyId'] = this.selectedPetitioner['_id']

  //   }
  //    if([50,51].indexOf(this.getUserRoleId)>-1){

  //   postData['companyId'] = this.checkProperty(this.getUserData ,"companyDetails" ,"_id")
  // }
       //this.beneficiaryMasterDataList =[];
       this.isListloading = true;
      this.updateLoading(true);
       this.$store
        .dispatch("petitioner/getbeneficiaries", postData)
        .then(response => {
          this.isListLoading =false;
           this.updateLoading(false);
          let list = response.list;
         let petitioners =[];
          if(this.checkProperty(list,'length')){
            _.forEach(list ,(item)=>{
              
              if(this.checkProperty(item,'petitions','length')>0){
                _.forEach(item['petitions'] ,(obj)=>{
                  petitioners.push(obj)
                })
              }
              if(this.checkProperty(item,'perms','length')>0){
                _.forEach(item['perms'] ,(obj)=>{
                  petitioners.push(obj)
                })
              }
            })
          }
      //  _.forEach(this.beneficiaryMasterDataList ,(item)=>{
      //           if( item && ( _.has(item ,'name') || _.has(item ,'email')  )){

      //                    if((_.has(item ,'name') && item['name'].includes(text)) || (_.has(item ,'email') && item['email'].includes(text)) ){
      //                     filteredData.push(item)
      //                    }else{
      //                       return false;
      //                    }

      //           }else{
      //             return false;
      //           }
              
           
      //    })

        //  if(filteredData.length<=0){
        //    this.enableAddNewBenTag =true;
        //  }
       
        this.petitioners= _.orderBy(petitioners, 'updatedOn' ,'desc');

          }).catch((err) => {
          
          this.isListLoading =false;
           this.updateLoading(false);
            this.petitioners = [];
           
       });

    },
      //////////////////////////////////////////


    goto(Id){
      let routeTest = this.$route.params.itemId
          this.$router.push({ name: 'petition-details', params: { itemId:Id } ,query: {'filter':this.encodedString} }).catch(err => {})
    },
    petitionlink(ticket) {
      let routedId = ticket._id;
      if(this.checkProperty(ticket,'subTypeDetails','id') == 15){
        if(this.checkProperty(ticket ,'statusId') == 1){
          if(this.checkProperty(ticket ,'intStatusDetails','id') == 1){
            this.$router.push({ path: `/perm-questionnaire/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
          }else{
            return false;
          }
        }else{
          this.$router.push({ path: `/gc-employment-details/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
        }
      }
      else if(! this.checkProperty(ticket, 'questionnaireFilled') && this.checkProperty(ticket, 'type') == 4 && this.checkProperty(ticket,'subTypeDetails','id') == 18){
       if(this.IsSponsorLogin){
        if(_.has(ticket, 'isFillSponsorQuestionnaire') && ticket['isFillSponsorQuestionnaire'] ){
          this.$router.push({ path: `/petition-details/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
        }else{
          this.$router.push({ name: "sponsor-questionnaire", params: { itemId: routedId } });
        }
       }else{
        if(_.has(ticket, 'isFillBenfQuestionnaire') && ticket['isFillBenfQuestionnaire'] ){
          this.$router.push({ path: `/petition-details/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
        }else{
          if(_.has(ticket, 'fillTheQuestionnire') && ticket['fillTheQuestionnire'] == 'Beneficiary'){
            this.$router.push({ path: `/questionnaire/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
          }
        }
       }
      }
      else if(! this.checkProperty(ticket, 'questionnaireFilled') && this.checkProperty(ticket, 'type') == 5){
        if(_.has(ticket, 'isFillBenfQuestionnaire') && ticket['isFillBenfQuestionnaire'] ){
          this.$router.push({ path: `/petition-details/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
        }else{
          if(_.has(ticket, 'fillTheQuestionnire') && ticket['fillTheQuestionnire'] == 'Beneficiary'){
            //this.$router.push({ name: "questionnaire", params: { itemId: routedId, 'redirect':true} });
            this.$router.push("/questionnaire/"+routedId+"?redirect=true");
            // this.$router.push({ path: `/questionnaire/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
          }
        }
      }
      else{
        if(this.checkProperty(ticket ,'statusId') == 1 && this.checkProperty(ticket, 'typeDetails','id') !=9){
          if(this.checkProperty(ticket ,'intStatusDetails','id') == 1){
            this.$router.push({ path: `/questionnaire/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
          }else{
            return false
          }
        }else{
          this.$router.push({ path: `/petition-details/${routedId}` ,query: {'filter':this.encodedString} }).catch(err => {});
        }
      }  
       
        
      
    },
    pageNate(pageNum) {
     
      this.page = pageNum;
      this.getpetitions();
    },
    SendQuestionnaireUser() {
      this.$store
        .dispatch("petitioner/sendquestionnaire", this.selecteduser)
        .then(response => {
          if (response.error) {
            Object.assign(this.formerrors, {
              msg: response.error.message
            });
          } else {
            this.$vs.notify({
              title: "Success",
              position: "top-right",
              color: "primary",              
              text: response.message
            });
            this.SendQuestionnaire = false;
            this.SuccessQuestionnaire = true;
            var timer = this.$router;
            setTimeout(function() {
              timer.go("/cases");
            }, 1000);
          }

          // this.petitioners = response.list;
        });
    },
    setuser(petition) {
      this.selecteduser.petitionId = petition._id;
      this.selecteduser.userName = petition.beneficiaryDetails.name;
      this.selecteduser.email = petition.beneficiaryDetails.email;
      this.selecteduser.typeName =
        petition.typeDetails.name + "/" + petition.subTypeDetails.name;
      this.selecteduser.subTypeName = petition.subTypeDetails.name;
    },
    selectCreatedDateRange(option) {
      option.startDate = moment(option.startDate).format("YYYY-MM-DD");
      option.endDate = moment(option.endDate).format("YYYY-MM-DD");
      this.selected_createdDateRange = [option.startDate, option.endDate];
    },
    // getDeletedCases(){
     
    //  if(_.has(this.selectedDeletedCase , "id")){
       

    //  }
      
    //  //this.set_filter();
      
    // },
    set_filter: function() {
      this.final_selected_statusids = [];

      if (this.selected_statusids.length > 0) {
        this.final_selected_statusids = [];
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }

      /*//states
        this.final_selected_states= [];
        if( this.seleted_states.length >0 ){
          this.final_selected_states = [];
          for(let ind =0;ind < this.seleted_states.length ; ind++ ){
            let current_index =  this.seleted_states[ind];
            this.final_selected_states.push(current_index["id"]);
          }
        }*/

      //alert(this.singel_final_selected_state);

      this.final_selected_locations = [];
      if (this.seleted_locations.length > 0) {
        for (let ind = 0; ind < this.seleted_locations.length; ind++) {
          let current_index = this.seleted_locations[ind];
          this.final_selected_locations.push(current_index["id"]);
        }
      }

      this.searchtxt = this.filter_searchtxt;

      this.getpetitions(true);
      this.$refs["filter_menu"].dropdownVisible = false;
    },
    clear_filter: function() {
      this.selectedarchive =[];
      this.selected_deadLineDateRange =  ["", ""];
      this.selectedpremiumProcessing = [];
      this.peritioners_search_value ='';
      this.searchtxt = "";
      this.selected_statusids = [];

      this.selected_country_obj = "";
      this.seleted_states = [];
      this.final_selected_states = [];
      this.singel_final_selected_state = "";

      this.seleted_locations = [];
      this.final_selected_locations = [];
      this.final_selected_statusids = [];

      this.date = "";
      this.date_range = [];
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";


      
      this.selectedVisaType =null;
      this.filter_searchtxt = "";
      this.selected_subtypes = [];
      this.final_selected_subtypes = [];

      (this.rolebased_filter = {
        3: { name: "supervisorIds", values: [] },
        4: { name: "paralegalIds", values: [] },
        5: { name: "attorneyIds", values: [] },
        9: { name: "offshoreUserIds", values: [] },
        10: { name: "evidenceSupervisorIds", values: [] }
      }),
        (this.final_selected_peritioners = []);
      this.selected_peritioners = [];
      //this.getPetitioners();
      this.$refs["filter_menu"].dropdownVisible = false;
      this.selected_users =[];
      this.selectedBranches =[];
     
      this.getpetitions();
       this.$router.push({ query: {} })
    },
    get_all_states() {
      this.$store.dispatch("getstates", this.country_code).then(response => {
        this.all_states = response;
      });
    },
    getAllLocations() {
      Object.assign(this.query, {
        countryId: this.country_code,
        stateId: this.singel_final_selected_state //this.final_selected_states//3922
      });

      this.$store.dispatch("getlocations", this.query).then(response => {
        this.all_locations = response;
      });
    },
    get_statusids() {
      Object.assign(this.query, {
        category: "company_statuses"
      });

      this.$store
        .dispatch("get_petition_statusids", this.query)
        .then(response => {
          this.all_statusids = response;
          if (this.checkProperty(this.$router.currentRoute ,"query"  ,"status") ){
         
          let status = this.checkProperty(this.$router.currentRoute ,"query"  ,"status");
          let selectedStatus = _.find(this.all_statusids ,{"id":parseInt(status)});
          
          if(selectedStatus){
            this.selected_statusids =[selectedStatus];
            this.final_selected_statusids =[parseInt(status)];

          }
          
        
        }
        });
    },
    setQueryString(obj){
      const string = JSON.stringify(obj) // convert Object to a String
      this.encodedString = btoa(string) // Base64 encode the String
    
     // var actual = JSON.parse(atob(encodedString))
    },
    getpetitions_old(callFromSerch=false ,filterObj=null) {
       this.selectedAllForArchive =false;
       this.selectedForArchiveList =[]; 
      this.callFromSerch = callFromSerch;
      let self =this;
      if(this.callFromSerch){
         
          this.petitioners  =[];
        }
      let obj = {
        matcher: {
          rfeCases:self.isRfe,
          searchString: self.searchtxt,
          statusIds: self.final_selected_statusids,
          beneficiaryIds:[],
          premiumProcessing:self.selectedpremiumProcessing.map((item)=> item._id),
          //"countryIds": [this.country_code],
          stateIds: [], //this.final_selected_statusids,
          locationIds: self.final_selected_locations,
          //"createdDateRange":this.selected_createdDateRange,
          petitionerIds:self.final_selected_peritioners,
          branchIds:[],
          typeIds:[],
          subTypeIds:[],
          deadlineDateRange:[],
          "getMissingDeadlines": false,
          petitionStatusList:[]
        },
        page: self.page,
        perpage: self.perpage,
        sorting:self.sortKey
      };

      if(self.selectedBranches.length>0){
        //obj['matcher']['branchIds'] = this.selectedBranches.map((item)=> item._id )
      }

     if(this.selectedarchive.length>0){

               obj["matcher"]["statusList"] = this.selectedarchive.map((item)=>item._id);

     }
  

      //
      if (this.singel_final_selected_state > 0) {
        obj["matcher"]["stateIds"] = [this.singel_final_selected_state];
      }

      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        obj["matcher"]["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"]
        ];
      }

      if (
        this.selected_deadLineDateRange["startDate"] &&
        this.selected_deadLineDateRange["startDate"] != "" &&
        this.selected_deadLineDateRange["endDate"] != "" &&
        this.selected_deadLineDateRange["endDate"]
      ) {
          obj["matcher"]["getMissingDeadlines"] = false;
          obj["matcher"]["deadlineDateRange"] = [
          this.selected_deadLineDateRange["startDate"],
          this.selected_deadLineDateRange["endDate"]
        ];
      }

      //selected_deadLineDateRange

      obj["matcher"]["countryIds"] = [];
      if (
        this.selected_country_obj["id"] &&
        this.selected_country_obj["id"] > 0
      ) {
        obj["matcher"]["countryIds"] = [this.selected_country_obj["id"]];
      }
      //
      if(this.selectedVisaType && _.has(this.selectedVisaType , 'id' )){
        
         obj["matcher"]["typeIds"] = [this.selectedVisaType['id']];
          obj["matcher"]["subTypeIds"] = this.final_selected_subtypes;

      }

      if(this.beneficiaryId !=null){
        obj["matcher"]['beneficiaryIds'] =[];
        obj["matcher"]['beneficiaryIds'].push(this.beneficiaryId)
      }

      //final_selected_subtypes
     

      //rolebased_filter

      // Object.keys(this.rolebased_filter).forEach(key => {
      //   let filtered_item = this.rolebased_filter[key]; // value of the current key
      //   obj["matcher"][filtered_item["name"]] = filtered_item["values"];
      // });
      if(filterObj && (Object.keys(filterObj)).length>0 ){
      _.forEach(filterObj ,(item ,key) => {
          if(key=='matcher' ){
            if((Object.keys(item)).length>0 ){
               obj['matcher'] = item
            }
           
          }
          
          if(key =='page' && item >0){
            obj['page'] = parseInt(item)
             this.page = parseInt(item)
          }
          if(key =='perpage' && item >0){
            obj['perpage'] = parseInt(item)
            
             this.perpage = parseInt(item)
          }
          if(key=='sorting' ){
            if((Object.keys(item)).length>0 ){
               obj['sorting'] = item
            }
           
          }
      })
    }
   
      this.setQueryString(obj)

      this.isListloading = true;
      this.updateLoading(true);
      this.$store.dispatch("petitioner/getpetitions", obj).then(response => {
         this.isListloading = false;
        this.updateLoading(false);
        
         let tempList =[];
         let list = response.list
         _.forEach( list,(item) => {
            item =Object.assign(item,{ 'selectedForArchive':false});
           if(this.selectedForArchiveList.indexOf(item['_id'])>-1){
              item =Object.assign(item,{ 'selectedForArchive':true});
           }
           tempList.push(item)
           
         });
          //this.petitioners = list;




       
        this.totalpages = Math.ceil(response.totalCount / this.perpage);
       
         //alert(this.totalpages);
      }) .catch((err) => {
          
           this.isListLoading =false;
            this.updateLoading(false);
             this.petitioners = [];
            
        });
    },
    getBeneficiaryPetitions(callFromSerch=false ,filterObj=null) {
      this.selectedAllForArchive =false;
      this.selectedForArchiveList =[]; 
      this.callFromSerch = callFromSerch;
      let self =this;
      if(this.callFromSerch){
          this.petitioners  =[];
        }
      let obj = {
        matcher: {
          rfeCases:self.isRfe,
          searchString: self.searchtxt,
          statusIds: self.final_selected_statusids,
          beneficiaryIds:[],
          premiumProcessing:self.selectedpremiumProcessing.map((item)=> item._id),
          stateIds: [], 
          locationIds: self.final_selected_locations,
          petitionerIds:self.final_selected_peritioners,
          branchIds:[],
          typeIds:[],
          subTypeIds:[],
          deadlineDateRange:[],
          "getMissingDeadlines": false,
          statusList:[],
          "getPetitionStats": true
        },
        page: self.page,
        perpage: self.perpage,
        sorting:self.sortKey
      };

      if(self.selectedBranches.length>0){
        //obj['matcher']['branchIds'] = this.selectedBranches.map((item)=> item._id )
      }
     if(this.selectedarchive.length>0){
        obj["matcher"]["statusList"] = this.selectedarchive.map((item)=>item._id);
     }

      if (this.singel_final_selected_state > 0) {
        obj["matcher"]["stateIds"] = [this.singel_final_selected_state];
      }

      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        obj["matcher"]["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"]
        ];
      }
      if (
        this.selected_deadLineDateRange["startDate"] &&
        this.selected_deadLineDateRange["startDate"] != "" &&
        this.selected_deadLineDateRange["endDate"] != "" &&
        this.selected_deadLineDateRange["endDate"]
      ) {
          obj["matcher"]["getMissingDeadlines"] = false;
          obj["matcher"]["deadlineDateRange"] = [
          this.selected_deadLineDateRange["startDate"],
          this.selected_deadLineDateRange["endDate"]
        ];
      }
      obj["matcher"]["countryIds"] = [];
      if (
        this.selected_country_obj["id"] &&
        this.selected_country_obj["id"] > 0
      ) {
        obj["matcher"]["countryIds"] = [this.selected_country_obj["id"]];
      }

      if(this.selectedVisaType && _.has(this.selectedVisaType , 'id' )){
        
         obj["matcher"]["typeIds"] = [this.selectedVisaType['id']];
          obj["matcher"]["subTypeIds"] = this.final_selected_subtypes;

      }
      if(this.beneficiaryId !=null){
        obj["matcher"]['beneficiaryIds'] =[];
        obj["matcher"]['beneficiaryIds'].push(this.beneficiaryId)
      }
      if(filterObj && (Object.keys(filterObj)).length>0 ){
      _.forEach(filterObj ,(item ,key) => {
          if(key=='matcher' ){
            if((Object.keys(item)).length>0 ){
               obj['matcher'] = item
            }
          }
          if(key =='page' && item >0){
            obj['page'] = parseInt(item)
             this.page = parseInt(item)
          }
          if(key =='perpage' && item >0){
            obj['perpage'] = parseInt(item)
            
             this.perpage = parseInt(item)
          }
          if(key=='sorting' ){
            if((Object.keys(item)).length>0 ){
               obj['sorting'] = item
            }
          }
      })
    }
      this.setQueryString(obj)
      this.isListloading = true;
      this.updateLoading(true);
      this.$store.dispatch("commonAction", {"data":obj ,"path":"/users/list"}).then(response => {
         this.isListloading = false;
        this.updateLoading(false);
        
          this.petitioners = list;




       
        this.totalpages = Math.ceil(response.totalCount / this.perpage);
       
         //alert(this.totalpages);
      }) .catch((err) => {
          
           this.isListLoading =false;
            this.updateLoading(false);
             this.petitioners = [];
            
        });
    },

    changedCountry() {
      this.country_code = this.selected_country_obj["id"];
      this.get_all_states();
    },

    changedState() {
      this.singel_final_selected_state = "";
      this.final_selected_locations = [];
      this.singel_final_selected_state = this.seleted_states["id"];
      this.final_selected_states.push(this.seleted_states["id"]);
      this.getAllLocations();
    },
    multiple_changedState() {
      // alert();
      if (this.seleted_states.length > 0) {
        this.final_selected_states = [];
        for (let ind = 0; ind < this.seleted_states.length; ind++) {
          let current_index = this.seleted_states[ind];
          this.final_selected_states.push(current_index["id"]);
        }
        this.getAllLocations();
      } else {
        this.final_selected_states = [];
        this.final_selected_locations = [];
      }
    },
   getVisaTypes(){
     let item ={
          matcher:{
              "searchString":'',
              getWorkFlowConfig:true
             // "petitionType":

          },   
          page:this.page,
          perpage: this.perpage,
          category: "petition_types",
         "sorting": {
            "path": "name",
            "order": 1
            }
          
        };

        this.$store
          .dispatch("getMasterData",item )
          .then(response => {
            this.visaTypes = response.list;

             if(this.checkProperty(this.$route ,'query' ,'filter')){
                try{
                  let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
                  var actual = JSON.parse(atob(filter));
                  let keys = Object.keys(actual);
                  if(this.checkProperty(keys ,'length') >0){


                    if(actual && (Object.keys(actual)).length>0 ){
                    _.forEach(actual ,(item ,key) => {
                        if(key=='matcher' ){
                          
                          if((Object.keys(item)).length>0 ){

                            if(_.has(item ,'typeIds') && this.checkProperty(item , 'typeIds' ,'length')>0 ){
                               
                              this.selectedVisaType = _.find(this.visaTypes ,{"id":item['typeIds'][0]})
                           
                             this.getvisa_subtypes();
                           
                            }

                            
                            
                          }
                        
                        }
                      
                        
                    
                    })
                  }
                    
                    
                  }

                }catch(e){
                  

                }
                  
              }


           
          });
   },
   changedVisaType(item){
     this.selectedVisaType = item;
     this.all_subtypes = [];
     this.final_selected_subtypes = [];
     this.selected_subtypes =[];
     if(_.has(this.selectedVisaType , "id")){
       this.getvisa_subtypes();

     }
   },
    getvisa_subtypes() {
      
      if(this.selectedVisaType && _.has(this.selectedVisaType ,"id")){
         
      
      let item = {
        matcher: {
          searchString: '',
          petitionType: parseInt(this.selectedVisaType['id']),
          getWorkFlowConfig: false,
        },
        page: 1,
        perpage: 1000,
        category: "petition_sub_types",
        "sorting": {
            "path": "name",
            "order": 1
            }
      };

      this.$store.dispatch("getMasterData", item).then((response) => {
        this.all_subtypes = response.list;

         if(this.checkProperty(this.$route ,'query' ,'filter')){
                try{
                  let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
                  var actual = JSON.parse(atob(filter));
                  let keys = Object.keys(actual);
                  if(this.checkProperty(keys ,'length') >0){


                    if(actual && (Object.keys(actual)).length>0 ){
                    _.forEach(actual ,(item ,key) => {
                        if(key=='matcher' ){
                          
                          if((Object.keys(item)).length>0 ){

                            if(_.has(item ,'subTypeIds')){
                              
                          
                              this.selected_subtypes = _.filter(this.all_subtypes ,(status)=>{
                                  return item['subTypeIds'].indexOf(status['id'])>-1;

                            })

                            }

                            
                            
                          }
                        
                        }
                      
                        
                    
                    })
                  }
                    
                    
                  }

                }catch(e){
                  

                }
                  
              }
       
      });
      }
    },
    changedsubtypes() {
      this.final_selected_subtypes = [];
      if (this.selected_subtypes.length > 0) {
        for (let ind = 0; ind < this.selected_subtypes.length; ind++) {
          let current_index = this.selected_subtypes[ind];
          this.final_selected_subtypes.push(current_index["id"]);
        }
      }
    },
    getusers() {
      let matcher = {
        roleIds: this.final_filter_roleIds,
        searchString: this.user_search_value,
        page: 1
      };
      let query = {};
      query["page"] = 1;
      query["perpage"] = 100;
      query["matcher"] = matcher;

      this.$store.dispatch("getusers", query).then(response => {
        this.users = response.list;
      });
    },
    get_peritioners() {

     
           
     //petitioner_list_for_tenant_users

       let item ={
          page:1,
          perpage: 10000,
          category: "petitioner_list_for_tenant_users",
          matcher:{
            "searchString":this.peritioners_search_value,
          
          },
          "sorting": {
            "path": "name",
            "order": 1
            }
                      
        };
        if([51].indexOf(this.getUserRoleId)>-1){
          item['category'] = "petitioner_list_for_beneficaries"
        }

  
        this.$store.dispatch("getMasterData", item).then(response => {
         
          this.all_peritioners =response.list;
              if(this.checkProperty(this.$route ,'query' ,'filter')){
                try{
                  let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
                  var actual = JSON.parse(atob(filter));
                  let keys = Object.keys(actual);
                  if(this.checkProperty(keys ,'length') >0){


                    if(actual && (Object.keys(actual)).length>0 ){
                    _.forEach(actual ,(item ,key) => {
                        if(key=='matcher' ){
                          
                          if((Object.keys(item)).length>0 ){

                            if(_.has(item ,'petitionerIds')){
                              
                              this.all_peritioners = _.filter(this.all_peritioners ,(status)=>{
                                  return item['petitionerIds'].indexOf(status['_id'])>-1;

                            })

                            }

                            
                            
                          }
                        
                        }
                      
                        
                    
                    })
                  }
                    
                    
                  }

                }catch(e){
                  

                }
                  
              }

          
        
        });
    },
    changedusers() {
      //rolebased_filter
      this.rolebased_filter = {
        3: { name: "supervisorIds", values: [] },
        4: { name: "paralegalIds", values: [] },
        5: { name: "attorneyIds", values: [] },
        9: { name: "offshoreUserIds", values: [] },
        10: { name: "evidenceSupervisorIds", values: [] }
      };
      if (this.selected_users.length > 0) {
        for (let i = 0; i < this.selected_users.length; i++) {
          let selected_user_item = this.selected_users[i];
          let roleId = selected_user_item["roleId"][0];
          this.rolebased_filter[roleId]["values"].push(
            selected_user_item["_id"]
          );
        }
      }
    },
    user_search(searchValue) {
      this.user_search_value = searchValue;
      this.getusers();
    },

    //
    changedperitioners() {
      this.final_selected_peritioners = [];
      if (this.selected_peritioners.length > 0) {
        for (let i = 0; i < this.selected_peritioners.length; i++) {
          this.final_selected_peritioners.push(
            this.selected_peritioners[i]["_id"]
          );
        }
      }
      this.get_peritioners_beneficiaries();
    },
    peritioners_search_fun(searchValue) {
      this.peritioners_search_value = searchValue;
      this.get_peritioners();
    },
    get_peritioners_beneficiaries() {},
    sortMe(sort_key=''){

      //   this.sortKeys = {
      //   'caseNo':1,
      //   'beneficiaryDetails.name':1,
      //   "typeDetails.name":1,
      //   "petitionerDetails.name":1,
      //   "updatedOn":1,
      //   "communicationDetailslength":1

      // }

      if(sort_key !=''){
          this.sortKeys[sort_key] = this.sortKeys[sort_key]==1?-1:1
          this.sortKey ={};
          this.sortKey= {"path":sort_key,"order": this.sortKeys[sort_key] }

          localStorage.setItem('petitions_sort_key', sort_key);
          localStorage.setItem('petitions_sort_value', this.sortKey[sort_key]);
          this.getpetitions();
      }
          
      

    },
    changeperPage(){
     
      this.page = 1;
      localStorage.setItem('petitions_perpage', this.perpage);
      this.getpetitions(true);
     
      
    },
      getBranchList() {
         this.branchList =[];
      //  alert(JSON.stringify(this.searchtxt)) final_selected_statusids
         let item ={
          filters:{
              "title":'',
             "createdDateRange":[],
             "statusList":[], 
             "activeList": [],
             "countryIds":[],
             "stateIds":[],
             "locationIds":[]
           

          },
          getMasterData:true,   
          page:1,
          perpage: 1000,
          sorting:{"path":"createdOn" ,"order":-1},
         
        };

         
       
        this.$store
          .dispatch("getList",{"data":item ,"path":"/branch/list"} )
          .then(response => {
            
            this.branchList = response.list;
           if(this.branchList.length ==1){
             this.selectedBranch = this.branchList[0];
           }
          }).catch((error)=>{
               this.branchList =[];
          })
      }, 
  },

  mounted() {
    //console.log(JSON.stringify(this.$store.state.loginUserData))
    if (this.checkProperty(this.$router.currentRoute ,"query"  ,"status") ){
         
          let status = this.checkProperty(this.$router.currentRoute ,"query"  ,"status");
        
          
          if(status){
           
            this.final_selected_statusids =[parseInt(status)];

          }
          
        
        }
        if(this.checkProperty(this.$route ,'query' ,'page')>0){
            this.page = parseInt(this.checkProperty(this.$route ,'query' ,'page'))
        }
         if(this.checkProperty(this.$route ,'query' ,'search')){
            this.searchtxt =this.checkProperty(this.$route ,'query' ,'search')
        }
    //  this.visatype = {
    //     id: 1,
    //     name: "H-1B"
    //   }
    //    this.getvisasubtypes(this.visatype);
     this.getPetitioners();
    this.getvisatypes();
    this.username = this.$store.state.user.name;
    this.roleId = this.$store.state.user["roleId"][0];
    // this.getBeneficiaryPetitions()
//"path": "createdOn", updatedOn, createdByName, typeName, subTypeName, caseNo, statusName
    this.sortKeys = {
      'caseNo':1,
      'createdByName':1,
      "typeName":1,
      "subTypeName":1,
      "statusName":1,
      "createdOn":1,
      "updatedOn":-1,
      "clientName":1,
      "beneficiaryName":1
      
    },

   
     this.sortKey= {"path":'updatedOn',"order":-1};

    if(localStorage.getItem('petitions_sort_key') && localStorage.getItem('petitions_sort_value')  && localStorage.getItem('petitions_sort_value') >=-1 ){
       this.sortKey = {};

      this.sortKey = {"path":localStorage.getItem('petitions_sort_key') ,"order":parseInt(localStorage.getItem('petitions_sort_value'))};
      this.sortKeys[localStorage.getItem('petitions_sort_key')] = parseInt(localStorage.getItem('petitions_sort_value'));

      //alert();
    }
    if(localStorage.getItem('petitions_perpage')){
        this.perpage = parseInt(localStorage.getItem('petitions_perpage'));
    }

    this.getvisaforNewCase();
    this.getVisaTypes();  
    this.getusers();
    this.get_peritioners();
    this.currentuserRole = this.$store.state.user.loginRoleId;

      if(this.checkProperty(this.$route ,'query' ,'filter')){
        try{
           let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
          var actual = JSON.parse(atob(filter));
          let keys = Object.keys(actual);
          if(this.checkProperty(keys ,'length') >0){
            
            
             this.getpetitions( false,actual);
          }else{
            this.getpetitions();
          }

        }catch(e){
           this.getpetitions();

        }
        
          
      }else{

          this.getpetitions();

      }
   
    this.$store.dispatch("getcountries").then(response => {
      this.countries = response;
    });

    this.selected_statusids = [];
    this.final_selected_statusids = [];
    this.seleted_states = [];
    this.final_selected_states = [];

    this.seleted_locations = [];
    this.final_selected_locations = [];
    this.get_statusids();
    //if([3].indexOf(this.getUserRoleId) >-1){
      this.getBranchList();
  //  }

  if(this.checkProperty(this.beneficiaryInfo ,"name")){
  this.selectedUser = this.beneficiaryId;
  this.selectedUsername =this.beneficiaryInfo['name']

  }
  },
  computed:{
    checkFillQuestionnaire(){
      return (ticket)=>{
        let returnVal = false;
        if((! this.checkProperty(ticket, 'questionnaireFilled') && this.checkProperty(ticket ,'intStatusDetails','id') == 1 && [5,4,9].indexOf(this.checkProperty(ticket, 'typeDetails', 'id'))<=-1)){
          returnVal = true;
        }
        if(! this.checkProperty(ticket, 'questionnaireFilled') && [4].indexOf(this.checkProperty(ticket, 'typeDetails', 'id'))>-1 && this.checkProperty(ticket,'subTypeDetails','id') == 18){
          if(this.IsSponsorLogin){
            if(_.has(ticket, 'isFillSponsorQuestionnaire') && ticket['isFillSponsorQuestionnaire'] ){
              returnVal = false;
            }else{
              returnVal = true;
            }
          }else{
            if(_.has(ticket, 'isFillBenfQuestionnaire') && ticket['isFillBenfQuestionnaire'] ){
              returnVal = false;
            }else{
              if(_.has(ticket, 'fillTheQuestionnire') && ticket['fillTheQuestionnire'] == 'Beneficiary'){
                returnVal = true;
              }
             
            }
          }
        }
        if(! this.checkProperty(ticket, 'questionnaireFilled') && [5].indexOf(this.checkProperty(ticket, 'typeDetails', 'id'))>-1){
          if(_.has(ticket, 'isFillBenfQuestionnaire') && ticket['isFillBenfQuestionnaire'] ){
            returnVal = false;
          }else{
            if(_.has(ticket, 'fillTheQuestionnire') && ticket['fillTheQuestionnire'] == 'Beneficiary'){
              returnVal = true;
            }
            
          }
        }
        return returnVal
      }
    },
    IsSponsorLogin(){
      let returnVal =false;
      let loginUserData = this.$store.state.loginUserData;
      if(this.checkProperty(loginUserData,'accountType') && this.checkProperty(loginUserData,'accountType')=='Individual' 
       && this.checkProperty(loginUserData,'accountSubType') && this.checkProperty(loginUserData,'accountSubType')=='Sponsor'){
        returnVal =true
      }else{
        returnVal =false
      }
    return returnVal;   
    },
    IsIndBeneficairyLogin(){
      let returnVal =false;
      let loginUserData = this.$store.state.loginUserData;
      if(this.checkProperty(loginUserData,'accountType') && this.checkProperty(loginUserData,'accountType')=='Individual' 
       && this.checkProperty(loginUserData,'accountSubType') && this.checkProperty(loginUserData,'accountSubType')=='Beneficiary'){
        returnVal =true
      }else{
        returnVal =false
      }
    return returnVal;   
    },
    checkEnableSelectAll(){
      let returnVal =false;
let activeItems = _.filter(this.petitioners ,(item)=>{
        return this.checkProperty( item ,'status') !=false
     });
     if(activeItems && this.checkProperty(activeItems ,'length')>0){
       returnVal =true;
     }
      return returnVal;
    }
  }
};
</script>
